import moment from 'moment'
import { convertFromRaw } from 'draft-js'

import uniqueString from 'secure-random-string'
import axios from 'axios'
import {
  BASE_URL_API as baseUrl,
  ACCESS_TOKEN as getToken,
} from 'utils/helpers'
import oauthSign from 'oauth-sign'
import {
  fetchGroups,
  fetchGroupsCourses,
  setIndividualCourses,
} from '../Group/actions'
import * as types from './types'
import {
  SET_SELECTED_ASSIGNABLE_TRAINING_USERS,
  SET_SELECTED_ASSIGNABLE_TRAINING_STORES,
  SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS,
  SET_SELECTED_ASSIGNABLE_TRAINING_ROLES,
} from '../Group/types'
import { reset, preloader } from '../Preloader/actions'
import { quiz as courseQuiz } from '../Quiz/actions'
import { toast } from 'react-toastify'
import AxiosInstance from 'utils/AxiosInstance'
import { clientBaseUrl } from 'utils/AxiosInstance'
import { fetchAllGroups, fetchAllGroupsCourses } from 'store/Group/actions'
import history from '../../utils/history'
import { invalidateCoursesOverview } from 'store/Dashboard/actions'
import { isTextEmpty } from 'utils/helpers'
import { setCompletedCoursesFetched } from 'store/Dashboard/actions'
import { setCompletedCoursesData } from 'store/Dashboard/actions'
import { v4 as uuidv4 } from 'uuid'

const question = {
  name: '',
  points: 1,
  options: [],
}
const isLoading = false

/*eslint-disable */
const randomNumber = () => Math.floor(Math.random() * Math.floor(100000))
const randomString = () => uniqueString()
const bool = [
  { name: 'True', value: 1, description: '', isDescriptionActive: false },
  { name: 'False', value: 2, description: '', isDescriptionActive: false },
]

const multiple = [
  { name: '', value: 1 },
  { name: '', value: 2 },
]

const defaultContainerPosition = {
  1: {
    id: 'TextContainer',
    text: 'Text Container',
    index: 0,
    type: 1,
  },
  2: {
    id: 'VideoContainer',
    text: 'Video Container',
    index: 1,
    type: 2,
  },
  4: {
    id: 'FileContainer',
    text: 'File Container',
    index: 2,
    type: 4,
  },
  8: {
    id: 'ScormContainer',
    text: 'Scorm Container',
    index: 3,
    type: 8,
  },
  5: {
    id: 'HtmlContainer',
    text: 'Html Container',
    index: 4,
    type: 5,
  },
}

export const resetCourse = () => ({ type: types.RESET })
export const increaseIframeKey = () => ({ type: types.INCREASE_IFRAME_KEY })
export const setProgress = (data) => ({ type: types.PROGRESS, data })
export const undo = () => ({ type: types.UNDO })
export const closeQuizModal = () => ({ type: types.CLOSE_QUIZ_MODAL })

export const present = () => ({ type: types.PRESENT })
export const toggleUploadPage = (mode) => ({
  type: types.TOGGLE_UPLOAD_PAGE,
  mode,
})
export const toggleUploadFilePage = (mode) => ({
  type: types.TOGGLE_UPLOAD_FILE_PAGE,
  mode,
})
export const sectionActiveIndex = (index) => ({
  type: types.SECTION_ACTIVE_INDEX,
  index,
})
export const cancelSection = () => (dispatch) => dispatch(undo())
export const onChangeDescription = (name, value) => ({
  type: types.UPDATE_DESCRIPTION,
  name,
  value,
})
export const toggleUploadScormPage = (mode) => ({
  type: types.TOGGLE_UPLOAD_SCORM_PAGE,
  mode,
})
export const updateContent = (content) => ({
  type: types.UPDATE_CONTENT,
  newContent: content,
})

export const setContentLoading = (value) => ({
  type: types.SET_CONTENTS_LOADING,
  contentLoading: value,
})
export const setSearchValue = (value) => ({
  type: types.SET_SEARCH_VALUE,
  value,
})
export const setShowCertificate = () => ({ type: types.SET_SHOW_CERTIFICATE })
export const setHideCertificate = () => ({ type: types.SET_HIDE_CERTIFICATE })
export const setShowFeedback = () => ({ type: types.SET_SHOW_FEEDBACK })
export const setHideFeedback = () => ({ type: types.SET_HIDE_FEEDBACK })

const toggleCreateCourseLoader = (isLoading) => ({
  type: types.COURSE_CREATE,
  isLoading,
})
export const setCloneId = (id) => ({ type: types.SET_CLONE_ID, id })
export const manageHtml = (html) => ({ type: types.MANAGE_HTML, html: html })
export const deleteHtml = () => ({ type: types.MANAGE_HTML, html: '' })
export const onChangeNewText = (value) => ({
  type: types.SET_NEW_TEXT_CONTENT,
  value,
})
export const onChangeTitleText = (value) => ({
  type: types.SET_TEXT_TITLE,
  title: value,
})

export const setCurrentTab = (tab) => ({ type: types.SET_CURRENT_TAB, tab })
export const setCurrentTabViewCourse = (tab) => ({
  type: types.SET_CURRENT_TAB_VIEW_COURSE,
  tab,
})
export const setPaginationItems = (items) => ({ type: types.SET_ITEMS, items })
export const setPaginationPageOfItems = (pageOfItems) => ({
  type: types.SET_PAGE_OF_ITEMS,
  pageOfItems,
})
export const onChangeConsumerKey = (value) => ({
  type: types.SET_CONSUMER_KEY,
  consumerKey: value,
})
export const onChangeSharedSecret = (value) => ({
  type: types.SET_CONSUMER_SECRET,
  sharedSecret: value,
})
export const onChangeCustomParameters = (value) => ({
  type: types.SET_CUSTOM_PARAMETERS,
  customParameters: value,
})
export const onChangeLaunchUrl = (value) => ({
  type: types.SET_LAUNCH_URL,
  launchUrl: value,
})

export const toggleFullscreen = (value) => ({
  type: types.SET_FULLSCREEN,
  isFullscreen: value,
})
export const resetLtiFields = () => ({ type: types.RESET_LTI_FIELDS })

const resetCourseActions = () => {
  return (dispatch, getState) => {
    const { progress } = getState().courses
    const index = progress.findIndex((item) => item.isActive)

    if (index === -1) {
      return
    }

    const newProgress = [
      ...progress.slice(0, index),
      { ...progress[index], isActive: false },
      ...progress.slice(index + 1),
    ]

    dispatch({ type: types.PROGRESS, data: newProgress })
    dispatch(setIndividualCourses())
  }
}

export const toggleCourseActions = (props) => {
  return (dispatch, getState) => {
    dispatch(resetCourseActions())

    const { progress } = getState().courses
    const index = progress.findIndex((item) => item.id === props.id)

    const newProgress = [
      ...progress.slice(0, index),
      { ...progress[index], isActive: !progress[index].isActive },
      ...progress.slice(index + 1),
    ]

    dispatch({ type: types.PROGRESS, data: newProgress })
    dispatch(setIndividualCourses())
  }
}

export const createCourse = () => {
  return (dispatch, getState) => {
    dispatch(reset())
    const {
      name,
      description,
      promote,
      categoryId,
      thumbFile,
      createCourseLoading,
      redirectUrl,
      language,
      rewardPoints,
      selfAssignable,
      dontShowOnManagerReport,
      courseGroups,
    } = getState().courses
    let userLanguage = {}
    getState().language.language
      ? (userLanguage = getState().language.language.data)
      : null
    if (isTextEmpty(name) || isTextEmpty(description)) {
      alert(
        userLanguage.alerts
          ? userLanguage.alerts.type_course_name_and_description
          : null
      )
    }

    if (isTextEmpty(name) || isTextEmpty(description) || createCourseLoading) {
      return
    }

    const data = new FormData()

    if (thumbFile) {
      data.append('file', thumbFile)
    }

    if (name) {
      data.append('name', name)
    }
    if (description) {
      data.append('description', description)
    }
    if (promote) {
      data.append('promote', promote)
    }
    if (categoryId) {
      data.append('category_id', categoryId)
    }
    if (redirectUrl) {
      data.append('redirect_url', redirectUrl)
    }
    if (language) {
      data.append('language_id', language)
    }
    if (rewardPoints) {
      data.append('reward_points', rewardPoints)
    }
    if (selfAssignable) {
      data.append('self_assignable', selfAssignable)
    }
    if (dontShowOnManagerReport) {
      data.append('dont_show_on_manager_report', dontShowOnManagerReport)
    }
    if (courseGroups) {
      data.append('groups', JSON.stringify(courseGroups))
    }

    dispatch(toggleCreateCourseLoader(true))

    AxiosInstance.post(`/courses`, data).then((data) => {
      dispatch(course(data.id))
      dispatch(fetchCourseGroups(data.id))
      dispatch(progress())
      dispatch(toggleCreateCourseLoader(false))
    })
  }
}

export const onSelectDetailCourseThumb = (thumbFile) => {
  return (dispatch, getState) => {
    const fileReader = new FileReader()

    fileReader.onload = (evt) => {
      dispatch({
        type: types.COURSE_THUMBNAIL,
        thumbValue: evt.target.result,
      })
    }

    fileReader.readAsDataURL(thumbFile)

    dispatch({ type: types.COURSE_THUMBNAIL_FILE, thumbFile })
  }
}

export const onSelectCourseThumb = (thumbFile) => {
  return (dispatch, getState) => {
    const { id, language } = getState().courses

    const fileReader = new FileReader()

    fileReader.onload = (evt) => {
      dispatch({
        type: types.COURSE_THUMBNAIL,
        thumbValue: evt.target.result,
      })
    }

    fileReader.readAsDataURL(thumbFile)

    dispatch({ type: types.COURSE_THUMBNAIL_FILE, thumbFile })

    if (id != -1) {
      const data = new FormData()

      data.append('file', thumbFile)
      data.append('language_id', language)

      AxiosInstance.patch(`/courses/${id}`, data).then((res) => {
        dispatch({ type: types.SET_IMAGE, image: res.image })
        dispatch(saveCourse())
        dispatch(progress())
      })
    }
  }
}

export const deleteCourse = (id) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_course_confirm : null)
    ) {
      AxiosInstance.delete(`/courses/${id}`).then(() => {
        // this was causing an infinite loading spinner when deleting a course
        // dispatch(fetchAllGroups())

        dispatch(progress())
        dispatch(fetchCourses())
        dispatch(setIndividualCourses(id))
      })
    }
  }
}

export const fetchContents = (id, languageId) => {
  return (dispatch) => {
    // Fetch the finished-content ids first and use that resolved value
    // directly below - reading finishedContent out of state here would race
    // fetchFinishedContent's own request and mark items completed based on
    // a stale (pre-fetch) snapshot, so a just-finished item wouldn't show as
    // completed until the next full reload.
    AxiosInstance.get(`/users/self/course-content-finished/${id}`).then(
      (finishedContent) => {
        dispatch({ type: types.SET_FINISHED_CONTENT, finishedContent })

        AxiosInstance.get(
          `/courses/${id}/languages/${languageId}/contents`
        ).then((data) => {
          if (Array.isArray(data)) {
            data.sort((a, b) => (a.position > b.position ? 1 : -1))
            if (data[0] && data[0].required !== 1) {
              data[0] ? (data[0]['completed'] = true) : null
            }

            finishedContent.map((item) => {
              data.find((dataItem) =>
                dataItem.id === parseInt(item)
                  ? (dataItem['completed'] = true)
                  : null
              )
            })
            dispatch({ type: types.SET_CONTENTS, data })
            dispatch(handleText())
            dispatch(handleHtml())
            dispatch({ type: types.CONTAINERS_LOADED })
          }
          dispatch(setContentLoading(false))
        })
      }
    )
    dispatch(fetchRequiredContent(id))
  }
}

export const fetchFinishedContent = (id, callbackFn) => {
  return (dispatch) => {
    AxiosInstance.get(`/users/self/course-content-finished/${id}`).then(
      (data) => {
        dispatch({
          type: types.SET_FINISHED_CONTENT,
          finishedContent: data,
        })
      }
    )
  }
}

export const fetchRequiredContent = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/courses/${id}/contents`).then((data) => {
      const filteredRequiredContent = data.filter((item) => item.required === 1)
      dispatch({
        type: types.SET_CONTENT_REQUIRED,
        filteredRequiredContent: filteredRequiredContent,
      })
    })
  }
}

// export const finishFirstContent = (course_id, content_id) => {
// 	return (dispatch, getState) => {
// 		const { language } = getState().courses
// 		AxiosInstance.post(`/users/self/course-content-finished`, {
// 			course_id,
// 			content_id,
// 		}).then((data) => {
// 			const returnData = data.data
// 			if (returnData.rewardsClaimed && returnData.rewardsClaimed.length) {
// 				dispatch({
// 					type: types.SET_EARNED_REWARDS_BADGES,
// 					data: returnData.rewardsClaimed,
// 				})
// 				dispatch({
// 					type: types.SET_EARNED_REWARDS_POINTS,
// 					data: returnData.pointsClaimed,
// 				})
// 				dispatch(showRewardOverlay())
// 			}
// 			dispatch(fetchFinishedContent(course_id))
// 			dispatch(fetchContents(course_id, language))
// 			dispatch(fetchUserProgressByCourseId(course_id))
// 			dispatch(fetchUserProgress())
// 		})
// 	}
// }

export const finishContent = (courseId, contentId) => {
  return (dispatch, getState) => {
    const { language } = getState().courses
    const data = {
      courseId: courseId,
      contentId: contentId,
      language_id: language,
    }

    AxiosInstance.post(`/users/self/course-content-finished`, data).then(
      (data) => {
        const returnData = data.data
        if (
          returnData &&
          returnData.rewardsClaimed &&
          returnData.rewardsClaimed.length
        ) {
          dispatch({
            type: types.SET_EARNED_REWARDS_BADGES,
            data: returnData.rewardsClaimed,
          })
          dispatch({
            type: types.SET_EARNED_REWARDS_POINTS,
            data: returnData.pointsClaimed,
          })
          dispatch(showRewardOverlay())
        }

        dispatch(fetchContents(courseId, language))
        dispatch(fetchUserProgressByCourseId(courseId))
        dispatch(fetchUserProgress())
        dispatch(invalidateCoursesOverview())
      }
    )
  }
}

export const fetchTextContent = (id) => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const currentContent = content.find((item) => item.id === parseInt(id))

    if (currentContent) {
      dispatch({
        type: types.SET_TEXT_TITLE,
        title: content.find((item) => item.id === parseInt(id)).title,
      })
      dispatch({
        type: types.SET_TEXT_CONTENT,
        value: content.find((item) => item.id === parseInt(id)).html,
      })
    }
  }
}

export const fetchHtmlContent = (id) => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const currentContent = content.find((item) => item.id === parseInt(id))

    if (currentContent) {
      dispatch({
        type: types.SET_TEXT_TITLE,
        title: content.find((item) => item.id === parseInt(id)).title,
      })
      dispatch({
        type: types.SET_HTML_CONTENT,
        value: content.find((item) => item.id === parseInt(id)).html,
      })
    }
  }
}

export const fetchSubmission = (id) => {
  return (dispatch, getState) => {
    const { quiz } = getState().courses

    AxiosInstance.get(`/courses/${id}/submissions`).then((data) => {
      // quiz.questions.map((quiz) => {
      // 	if (!allQuestion.includes(quiz)) {
      // 		allQuestion.push(quiz)
      // 	}
      // })

      if (data && data.quiz) {
        let allQuestion = [...data.quiz]
        let questionsIds = data.quiz.map((quiz) => quiz.id)

        quiz.questions.map((quiz) => {
          if (!questionsIds.includes(quiz.id)) {
            allQuestion.push(quiz)
          }
        })

        console.log(data, 'leart551')

        dispatch(
          courseQuiz({
            questions: quiz.questions,
            submissions: data.quiz,
            status: data.quiz_status,
            quiz_score: data.quiz_score,
            message: data.message,
            quizAttempts: data.quiz_attempts,
          })
        )
      } else {
        dispatch(
          courseQuiz({
            questions: quiz?.questions,
            submissions: data?.quiz,
            status: 0,
            quiz_score: data?.quiz_score,
            message: data?.message,
            quizAttempts: data.quiz_attempts,
          })
        )
      }
    })
  }
}

export const course = (id) => {
  return (dispatch) => {
    dispatch(reset())
    dispatch({ type: types.COURSE, data: {} })
    dispatch(fetchTracking(id))
    dispatch(setContentLoading(true))
    AxiosInstance.get(`/courses/${id}`).then((data) => {
      const keywords =
        (data.keywords &&
          data.keywords.length &&
          data.keywords.map((item) => {
            return {
              id: item,
              name: item,
            }
          })) ||
        []
      data = { ...data, keywords }
      // dispatch({ type: types.RESET })
      dispatch(fetchContents(id, data.language_id))
      dispatch({ type: types.COURSE_LOADED })
      dispatch({ type: types.COURSE, data })
      dispatch(preloader())
      dispatch(courseQuiz(Object.assign({}, data.quiz), true))
      dispatch({ type: types.CONTAINERS_LOADED })
      dispatch(fetchSubmission(id))
    })
  }
}

export const fetchCourse = (id, languageId) => {
  return (dispatch) => {
    dispatch(reset())
    dispatch({ type: types.COURSE, data: {} })
    dispatch(fetchTracking(id))
    dispatch(fetchContents(id, languageId))

    AxiosInstance.get(`/courses/${id}/languages/${languageId}`).then((data) => {
      // dispatch({ type: types.RESET })
      dispatch({ type: types.COURSE_LOADED })
      dispatch({ type: types.COURSE, data })
      dispatch(courseQuiz(Object.assign({}, data.quiz), true))
      dispatch(fetchSubmission(id))
      dispatch({ type: types.CONTAINERS_LOADED })
      dispatch(preloader())
    })
  }
}

export const removeCourseTranslation = (id) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_language_confirm : null)
    ) {
      const { course_id, language } = getState().courses

      AxiosInstance.delete(`/courses/${course_id}/languages/${language}`).then(
        () => {
          dispatch(course(id))
          dispatch(fetchCourseAvailableLanguages(course_id))
        }
      )
    }
  }
}

export const list = () => {
  return (dispatch, getState) => {
    const { listLoaded } = getState().courses

    if (listLoaded) {
      return
    }
  }
}

export const progress = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/courses')
      .then((data) => {
        if (Array.isArray(data)) {
          dispatch({ type: types.PROGRESS, data })
        }
        dispatch(isLoading(types.LOADING, 'progressLoaded', true))
      })
      .catch((err) => {
        // dispatch(isLoading(types.LOADING, 'progressLoaded', false))
      })
  }
}

export const fetchManageableCourses = () => {
  return (dispatch) => {
    AxiosInstance.get(`/courses/manageable`).then((data) => {
      if (Array.isArray(data)) {
        dispatch({
          type: types.SET_MANAGEABLE_COURSES,
          manageableCourses: data,
        })
      }
    })
  }
}

const saveCourse = () => {
  return (dispatch, getState) => {
    const {
      name,
      promote,
      containerPosition,
      categoryId,
      language,
      redirectUrl,
      certificateFooterContent,
      quizAttemptsAllowed,
      course_id,
      languageIsReady,
      equivalentCourse,
      keywords,
      inactive,
      secondLevelApproval,
      checklistType,
      description,
      rewardPoints,
      selfAssignable,
      allowPublicAccess,
      enableCompletionFeedback,
      requireAgreement,
      remindUsers,
      emailFrequency,
      dontShowOnManagerReport,
      hideCourseSidebar,
      doNotShowCertificate,
      disablePdfDownload,
      allowCourseFeedback,
      allowCourseComments,
      expireDate,
      expirePeriod,
      setExpirationDate,
      enrollmentType,
      enrollmentPeriodType,
      enrollmentPeriod,
      price,
      newAccessCode,
    } = getState().courses

    const getExpirePeriod = () => {
      console.log(expirePeriod, 'expirePeriod')
      switch (expirePeriod) {
        case 'y':
          return 365
        case 'm':
          return 31
        case 'w':
          return 7
        case 'd':
          return 1
        default:
          break
      }
    }

    const expireDays = expireDate * getExpirePeriod()

    // const currentDate = new Date()

    // let expirationDate
    // if (expireDays) {
    //   expirationDate = new Date(
    //     currentDate.getTime() + Number(expireDays) * 24 * 60 * 60 * 1000
    //   )
    // } else {
    //   expirationDate = ''
    // }

    // const formattedExpirationDate =
    //   expirationDate && expirationDate.toISOString().slice(0, 10)

    dispatch(onSetActiveExpirationDate(expireDays))

    const { activeIndex, ...quiz } = getState().courses.quiz

    const { sectionActiveIndex, ...checklist } = getState().courses.checklist

    if (quiz.questions[activeIndex] && quiz.questions[activeIndex].type === 6) {
      dispatch(uploadMultipleFiles())
    }

    AxiosInstance.patch(`/courses/${course_id}`, {
      name,
      promote,
      redirect_url: redirectUrl,
      certificate_footer_content: certificateFooterContent,
      category_id: categoryId || null,
      quiz: JSON.stringify(quiz),
      quiz_attempts_allowed: quiz.retake ? quizAttemptsAllowed : null,
      quiz_pass_percentage: quiz.quizPassPercentage,
      // quiz_count: quiz.quizTimer,
      checklist: JSON.stringify(checklist),
      container_position: JSON.stringify(containerPosition),
      language_id: language,
      is_ready: languageIsReady,
      equivalent_id: equivalentCourse,
      is_active: inactive ? -1 : 1,
      require_approval: secondLevelApproval ? 1 : -1,
      checklist_type: checklistType,
      description,
      reward_points: rewardPoints,
      keywords: JSON.stringify(
        Array.isArray(keywords) && keywords.length
          ? keywords.map((item) => item.name)
          : []
      ),
      self_assignable: selfAssignable,
      allow_public_access: allowPublicAccess,
      enable_completion_feedback: enableCompletionFeedback,
      require_agreement: requireAgreement,
      remind_users: remindUsers,
      email_frequency: emailFrequency,
      dont_show_on_manager_report: dontShowOnManagerReport,
      hide_course_sidebar: hideCourseSidebar,
      do_not_show_certificate: doNotShowCertificate,
      disable_pdf_download: disablePdfDownload,
      allow_course_feedback: allowCourseFeedback,
      allow_comments: allowCourseComments,
      expire_days: `${expireDate} ${expirePeriod}`,
      allow_expiration_date: setExpirationDate ? 1 : 0,
      enrollment_type: enrollmentType,
      enrollment_period_type: enrollmentPeriodType,
      enrollment_period: enrollmentPeriod,
      price,
      ...(newAccessCode ? { access_code: newAccessCode } : {}),
    }).then(() => {
      dispatch({ type: types.QUESTION_ACTIVE_INDEX, activeIndex: -1 })
      if (!promote) {
        dispatch({
          type: types.SET_ALL_LANGUAGES_PROMOTED,
          payload: 0,
        })
      }
      dispatch(progress())
    })
  }
}

const saveContent = (data) => {
  return (dispatch, getState) => {
    const courseId = getState().courses.id
    if (data.id) {
      const { id, ...props } = data

      AxiosInstance.patch(`/courses/${courseId}/contents/${id}`, props)
      dispatch(setContentLoading(false))

      return
    }
  }
}

let timeout = 0
export const onChange = (event) => {
  return (dispatch, getState) => {
    const { id } = getState().courses
    const name = event.target.name
    const value = [
      'promote',
      'selfAssignable',
      'allowPublicAccess',
      'enableCompletionFeedback',
      'requireAgreement',
      'remindUsers',
      'dontShowOnManagerReport',
      'hideCourseSidebar',
      'allowCourseFeedback',
      'doNotShowCertificate',
      'disablePdfDownload',
      'allowCourseComments',
    ].includes(name)
      ? event.target.checked
        ? 1
        : 0
      : event.target.value

    if (name === 'allowPublicAccess' && value === 0) {
      dispatch(setEnrollmentType(0))
      dispatch(setNewAccessCode(null))
      dispatch(setEnrollmentPeriodType(0))
      dispatch(setEnrollmentPeriod(null))
    }

    dispatch({ type: types.ON_CHANGE, name, value })

    clearTimeout(timeout)

    if (id) {
      timeout = setTimeout(() => {
        dispatch(saveCourse())
      }, 700)
    }
  }
}

export const toggleQuizRetake = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_QUIZ_RETAKE })
    dispatch(saveCourse())
  }
}

export const togglePassPercentage = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_PASS_PERCENTAGE })
    dispatch(saveCourse())
  }
}

export const toggleQuizTimer = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_QUIZ_TIMER })
    dispatch(saveCourse())
  }
}
export const toggleQuizExpiration = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_QUIZ_EXPIRATION })
    dispatch(saveCourse())
  }
}

export const toggleRandomizeOrder = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_QUIZ_RANDOMIZE_ORDER })
    dispatch(saveCourse())
  }
}

export const selectQuestion = (event) => {
  return (dispatch, getState) => {
    const { questions } = getState().courses.quiz
    let randomId = randomString()

    const match = [
      { name: '', type: 1, id: randomId, selected: '' },
      { name: '', type: 2, id: randomString(), match: randomId },
    ]

    const value = parseInt(event.target.value)

    const activeIndex = questions.length

    const options =
      value !== 7 &&
      (value === 1 ? bool : value === 5 ? match : multiple).map((item) =>
        value === 5 ? { ...item } : { ...item, id: randomString() }
      )

    const newQuestions = [
      ...questions,
      {
        ...question,
        newQuestion: true,
        id: randomString(),
        type: value,
        options,
      },
    ]

    dispatch(present())
    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
    dispatch({ type: types.QUESTION_ACTIVE_INDEX, activeIndex })
  }
}

export const addDistraction = () => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]
    let newOptions = []
    newOptions = [
      ...options,
      { name: '', value: randomNumber(), id: randomString(), type: 3 },
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const addOption = () => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]
    let newOptions = []
    let randomId = randomString()

    questions[activeIndex].type === 5
      ? (newOptions = [
          ...options,
          { name: '', id: randomId, type: 1, selected: '' },
          { name: '', id: randomString(), type: 2, match: randomId },
        ])
      : (newOptions = [
          ...options,
          { name: '', value: randomNumber(), id: randomString() },
        ])

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const deleteOption = (index) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]

    const newOptions = [...options.slice(0, index), ...options.slice(index + 1)]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const deleteMatchOption = (id) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]
    const parentId = options.find((item) => item.id === id)
    const filteredOptions = options.filter((item) => item.id !== id)
    const newOptions = filteredOptions.filter(
      (item) => item.id !== parentId.match
    )

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const onChangeQuestion = (property, value) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], [property]: value },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const onChangeQuestionName = (value, editor) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], text: value },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const onChangeQuestionOptionDescription = (index, description) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]
    const newOptions = [
      ...options.slice(0, index),
      { ...options[index], description: description },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const setOptionImage = (index) => {
  return (dispatch, getState) => {
    // event.preventDefault()
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]

    const newOptions = [
      ...options.slice(0, index),
      {
        ...options[index],
        image: event.target.files[0],
        name: event.target.files[0].name,
        url: null,
        hasChanged: true,
      },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const uploadMultipleFiles = () => {
  return (dispatch, getState) => {
    const { course_id } = getState().courses
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]

    const data = new FormData()
    options.map((item) => {
      if (item.hasChanged) {
        data.append('files', item.image)
      }
    })

    AxiosInstance.post(
      `/courses/${course_id}/quiz/upload-multiple`,
      data,
      {}
    ).then(({ data }) => {
      if (data.length) {
        const newOptions = []

        let i = 0
        options.map((item) => {
          if (item.hasChanged) {
            item.url = data[i].url
            item.fileName = data[i].fileName
            delete item.image
            delete item.hasChanged
            i++
          }

          newOptions.push(item)
        })

        const newQuestions = [
          ...questions.slice(0, activeIndex),
          { ...questions[activeIndex], options: newOptions },
          ...questions.slice(activeIndex + 1),
        ]

        dispatch({
          type: types.ON_CHANGE_QUESTION,
          questions: newQuestions,
        })
        dispatch({ type: types.QUESTION_ACTIVE_INDEX, activeIndex: -1 })
        dispatch(saveCourse())
      }
    })
  }
}

export const toggleCurrentQuestionDescription = (index) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]

    const newOptions = [
      ...options.slice(0, index),
      {
        ...options[index],
        isDescriptionActive: !options[index].isDescriptionActive,
      },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const onChangeOption = (index, property, value) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]

    const newOptions = [
      ...options.slice(0, index),
      { ...options[index], [property]: value },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const onChangeOptionDescription = (description, index) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { options } = questions[activeIndex]

    const newOptions = [
      ...options.slice(0, index),
      { ...options[index], description: description },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })
  }
}

export const editQuestion = (activeIndex) => {
  return (dispatch) => {
    dispatch(present())
    dispatch({ type: types.QUESTION_ACTIVE_INDEX, activeIndex })
  }
}

export const deleteQuestion = (index) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_question_confirm : null)
    ) {
      const { questions } = getState().courses.quiz

      const newQuestions = [
        ...questions.slice(0, index),
        ...questions.slice(index + 1),
      ]

      // dispatch({ type: types.QUESTION_ACTIVE_INDEX, activeIndex: -1 })
      dispatch({
        type: types.ON_CHANGE_QUESTION,
        questions: newQuestions,
      })
      dispatch(saveCourse())
    }
  }
}
export const toggleCurrentContentQuizQuestionDescription = (index) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options } = questions[activeIndex]

    const newOptions = [
      ...options.slice(0, index),
      {
        ...options[index],
        isDescriptionActive: !options[index].isDescriptionActive,
      },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}
export const onChangeContentQuizOptionDescription = (description, index) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options } = questions[activeIndex]

    const newOptions = [
      ...options.slice(0, index),
      { ...options[index], description: description },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}
export const deleteOptionContentQuiz = (index) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options } = questions[activeIndex]

    const newOptions = [...options.slice(0, index), ...options.slice(index + 1)]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}

export const setOptionImageContentQuiz = (index) => {
  return (dispatch, getState) => {
    // event.preventDefault()
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options } = questions[activeIndex]

    const newOptions = [
      ...options.slice(0, index),
      {
        ...options[index],
        image: event.target.files[0],
        name: event.target.files[0].name,
        url: null,
        hasChanged: true,
      },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}
export const deleteMatchOptionContentQuiz = (id) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options } = questions[activeIndex]
    const parentId = options.find((item) => item.id === id)
    const filteredOptions = options.filter((item) => item.id !== id)
    const newOptions = filteredOptions.filter(
      (item) => item.id !== parentId.match
    )

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}

export const saveContentQuizQuestionFromBank = (questionsFromBank) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz

    // const { options, newQuestion, ...question } = questionFromBank

    let language = {}

    getState().language.language
      ? (language = getState().language.language.data)
      : null

    questionsFromBank.map((question) => {
      const { options } = question

      const empty = options.filter((item) => !item.name).length

      if (empty) {
        alert(language.alerts ? language.alerts.fill_all_fields : null)
        return
      }

      if (![3, 4, 5].includes(question.type) && !question.correct_answer) {
        alert(language.alerts ? language.alerts.select_one_answer : null)
        return
      }

      options.map((item) => {
        delete item.isDescriptionActive
      })

      return { ...question, options }
    })

    const newQuestions = [...questions, ...questionsFromBank]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })

    // dispatch(saveCourse())
  }
}
export const saveContentQuizQuestion = () => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options, newQuestion, ...question } = questions[activeIndex]
    const empty = options.filter((item) => !item.name).length

    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null

    if (empty) {
      alert(language.alerts ? language.alerts.fill_all_fields : null)
      return
    }

    if (
      ![3, 4, 5].includes(questions[activeIndex].type) &&
      !questions[activeIndex].correct_answer
    ) {
      alert(language.alerts ? language.alerts.select_one_answer : null)
      return
    }

    // options.map((item) => {
    // 	delete item.isDescriptionActive
    // })

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...question, options },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })

    dispatch({ type: types.SET_CONTENT_QUESTION_ACTIVE_INDEX, activeIndex: -1 })

    // dispatch(saveCourse())
  }
}

export const setTableData = (payload) => ({
  type: types.SET_TABLE_DATA,
  payload,
})

export const saveQuestion = () => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz
    const { tableData } = getState().courses
    const { options, newQuestion, ...question } = questions[activeIndex]
    const empty = options.length && options.filter((item) => !item.name).length

    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null

    if (
      empty &&
      questions[activeIndex].type !== 7 &&
      questions[activeIndex].type !== 8
    ) {
      alert(language.alerts ? language.alerts.fill_all_fields : null)
      return
    }

    if (
      ![3, 4, 5].includes(questions[activeIndex].type) &&
      !questions[activeIndex].correct_answer &&
      questions[activeIndex].type !== 7 &&
      questions[activeIndex].type !== 8
    ) {
      alert(language.alerts ? language.alerts.select_one_answer : null)
      return
    }

    options.length &&
      options.map((item) => {
        delete item.isDescriptionActive
      })

    // const newQuestions = [
    //   ...questions.slice(0, activeIndex),
    //   { ...question, options },
    //   ...questions.slice(activeIndex + 1),
    // ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      {
        ...question,
        options,
        ...(questions[activeIndex].type === 8 && { tableData }), // Add tableData if type is 8
      },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })

    dispatch(saveCourse())
  }
}

export const saveQuestionFromBank = (questionsFromBank) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.quiz

    // const { options, newQuestion, ...question } = questionFromBank

    let language = {}

    getState().language.language
      ? (language = getState().language.language.data)
      : null

    questionsFromBank.map((question) => {
      const { options } = question

      const empty = options.filter((item) => !item.name).length

      if (empty) {
        alert(language.alerts ? language.alerts.fill_all_fields : null)
        return
      }

      if (![3, 4, 5].includes(question.type) && !question.correct_answer) {
        alert(language.alerts ? language.alerts.select_one_answer : null)
        return
      }

      options.map((item) => {
        delete item.isDescriptionActive
      })

      return { ...question, options }
    })

    const newQuestions = [...questions, ...questionsFromBank]

    dispatch({ type: types.ON_CHANGE_QUESTION, questions: newQuestions })

    dispatch(saveCourse())
  }
}

export const uploadVideo = (event, handleCloseModal = null) => {
  return (dispatch, getState) => {
    event.preventDefault()
    const {
      course_id,
      uploadVideoStatus,
      requiredContent,
      title,
      language,
      restricVideo,
    } = getState().courses

    if (uploadVideoStatus === 'started') {
      return
    }

    const nodes = event.target.elements
    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]

    const type = 2
    const file = fileInput.files[0]
    const data = new FormData()
    data.append('title', title)
    data.append('file', file)
    data.append('type', type)
    data.append('required', requiredContent ? 1 : 0)
    data.append('restrict_video', restricVideo ? 1 : 0)
    data.append('language_id', language)

    let userLanguage = {}
    getState().language.language
      ? (userLanguage = getState().language.language.data)
      : null
    if (!file) {
      alert(userLanguage.alerts ? userLanguage.alerts.select_file : null)
      // alert('Please select a file')
      return
    }
    if (file && !file.type.includes('video')) {
      alert(
        'The type of this file is not a video, please try to upload a video file.'
      )
      return
    }

    dispatch({ type: types.UPLOAD_VIDEO_STATUS, status: 'started' })

    axios
      .post(
        `${clientBaseUrl()}/courses/${course_id}/files?token=${getToken()}`,
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )

            dispatch({ type: types.VIDEO_UPLOAD_PERCENT, percent })
          },
        }
      )
      .then(() => {
        dispatch({ type: types.UPLOAD_VIDEO_STATUS, status: '' })
        dispatch(toggleUploadPage(false))
        // dispatch({ type: types.SELECT_VIDEO_TYPE, value: 'up' })
        dispatch(fetchCourse(course_id, language))
        dispatch({ type: types.VIDEO_UPLOAD_PERCENT, percent: 0 })
        dispatch(fetchContents(course_id, language))
        dispatch({ type: types.SET_REQUIRED, requiredContent: true })
        dispatch({ type: types.SET_TEXT_TITLE, title: '' })
        if (handleCloseModal) {
          handleCloseModal()
        }
      })
  }
}

export const addUrlVideo = (event, handleCloseModal = null) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const { course_id, requiredContent, title, language, content } =
      getState().courses

    const nodes = event.target.elements
    const textInput = [].filter.call(nodes, (item) => item.type === 'text')
    const url = textInput[1].value
    const data = {
      url,
      name,
      title,
      type: 2,
      thumb: '',
      videoType: 'url',
      required: requiredContent ? 1 : 0,
      language_id: language,
    }
    AxiosInstance.post(`/courses/${course_id}/videos`, data).then(() => {
      dispatch(selectVideo(''))
      dispatch(fetchCourse(course_id, language))
      dispatch({ type: types.SET_REQUIRED, requiredContent: true })
      dispatch(toggleUploadPage(false))
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
      dispatch(fetchContents(course_id, language))

      if (handleCloseModal) {
        handleCloseModal()
      }
    })
  }
}

export const editVideo = (index) => {
  return (dispatch) => {
    dispatch(index === -1 ? undo() : present())
    dispatch({ type: types.EDIT_VIDEO, index })
  }
}

export const updateVideo = (value, id) => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const videoContent = content.find((item) => item.id === parseInt(id))
    const oldContent = content.filter((item) => item !== videoContent)

    videoContent.content[0].name = value

    const newContent = [...oldContent, videoContent]

    dispatch({ type: types.UPDATE_VIDEO, content: newContent })
  }
}

export const updateVideoContent = (videoId) => {
  return (dispatch, getState) => {
    const { content, title, language } = getState().courses

    const contentItem = content.find((item) => item.id === parseInt(videoId))
    const contentItemIndex = content.findIndex(
      (item) => item.id === parseInt(videoId)
    )

    let data = {
      id: parseInt(videoId),
      content: JSON.stringify(contentItem.content),
      required: contentItem.required,
      type: 2,
      position: contentItem.position,
      title,
      language_id: language,
    }

    if (contentItemIndex !== -1) {
      dispatch(setContentLoading(true))
      const newContent = [
        ...content.slice(0, contentItemIndex),
        data,
        ...content.slice(contentItemIndex + 1),
      ]

      dispatch(saveContent(data))
      dispatch({ type: types.SET_CONTENTS, data: newContent })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
    }
  }
}

export const deleteContent = (contentId, languageId) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_content_confirm : null)
    ) {
      const { course_id, language } = getState().courses
      AxiosInstance.delete(
        `/courses/${course_id}/contents/${contentId}/languages/${languageId}`
      ).then(() => dispatch(fetchContents(course_id, language)))
    }
  }
}

const section = () => ({
  onCreate: true,
  id: randomString(),
  name: '',
  rating: 'yes-no',
  items: [
    {
      id: randomString(),
      name: '',
      value: '',
      comment: '',
    },
    {
      id: randomString(),
      name: '',
      value: '',
      comment: '',
    },
  ],
})

const sectionItem = () => ({
  id: randomString(),
  name: '',
  value: '',
  comment: '',
})

export const addSection = () => {
  return (dispatch, getState) => {
    dispatch(present())

    const { checklist } = getState().courses

    const sections = [...checklist.sections, section()]

    dispatch({ type: types.ADD_SECTION, sections })
    dispatch({
      type: types.SECTION_ACTIVE_INDEX,
      index: sections.length - 1,
    })
  }
}

export const deleteSection = (index) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_section_confirm : null)
    ) {
      const { sections, sectionActiveIndex } = getState().courses.checklist

      if (sectionActiveIndex !== -1) {
        index = sectionActiveIndex
      }

      const newSections = [
        ...sections.slice(0, index),
        ...sections.slice(index + 1),
      ]

      dispatch({ type: types.SECTION_ACTIVE_INDEX, index: -1 })
      dispatch({ type: types.ADD_SECTION, sections: newSections })
      dispatch(saveCourse())
    }
  }
}

export const editSection = (index) => {
  return (dispatch) => {
    dispatch(present())

    dispatch({ type: types.SECTION_ACTIVE_INDEX, index })
  }
}

export const saveSection = () => {
  return (dispatch, getState) => {
    const { sectionActiveIndex, sections } = getState().courses.checklist

    const section = sections[sectionActiveIndex]
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (!section.name.trim()) {
      alert(language.alerts ? language.alerts.type_section_name : null)
      return
    }

    if (!section.items.length) {
      alert(language.alerts ? language.alerts.add_item : null)
      return
    }
    if (section.items.find((item) => !item.name.trim())) {
      alert(language.alerts ? language.alerts.add_item_value : null)
      return
    }

    const { onCreate, ...newSection } = section

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      newSection,
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
    dispatch(present())
    dispatch({ type: types.SECTION_ACTIVE_INDEX, index: -1 })
    dispatch(saveCourse())
  }
}

export const addSectionItem = () => {
  return (dispatch, getState) => {
    const { sectionActiveIndex, sections } = getState().courses.checklist

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      {
        ...sections[sectionActiveIndex],
        items: [...sections[sectionActiveIndex].items, sectionItem()],
      },
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
  }
}

export const removeSectionItem = (itemIndex) => {
  return (dispatch, getState) => {
    const { sections, sectionActiveIndex } = getState().courses.checklist

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      {
        ...sections[sectionActiveIndex],
        items: [
          ...sections[sectionActiveIndex].items.slice(0, itemIndex),
          ...sections[sectionActiveIndex].items.slice(itemIndex + 1),
        ],
      },
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
  }
}

export const saveDescription = () => {
  return (dispatch) => {
    dispatch(present())
    dispatch({ type: types.SECTION_ACTIVE_INDEX, index: -1 })
    dispatch(saveCourse())
  }
}

export const onChangeSection = (event) => {
  return (dispatch, getState) => {
    const name = event.target.name
    const value = event.target.value
    const { sections, sectionActiveIndex } = getState().courses.checklist

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      { ...sections[sectionActiveIndex], [name]: value },
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
  }
}

export const onChangeSectionItem = (itemIndex, value) => {
  return (dispatch, getState) => {
    const { sections, sectionActiveIndex } = getState().courses.checklist

    const newSections = [
      ...sections.slice(0, sectionActiveIndex),
      {
        ...sections[sectionActiveIndex],
        items: [
          ...sections[sectionActiveIndex].items.slice(0, itemIndex),
          {
            ...sections[sectionActiveIndex].items[itemIndex],
            name: value,
          },
          ...sections[sectionActiveIndex].items.slice(itemIndex + 1),
        ],
      },
      ...sections.slice(sectionActiveIndex + 1),
    ]

    dispatch({ type: types.ADD_SECTION, sections: newSections })
  }
}

export const uploadFile = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const { course_id, uploadFileStatus, requiredContent, title, language } =
      getState().courses

    if (uploadFileStatus === 'started') {
      return
    }

    const nodes = event.target.elements
    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]

    const type = 4
    const file = fileInput.files[0]

    const data = new FormData()

    data.append('file', file)
    data.append('type', type)
    data.append('title', title)
    data.append('required', requiredContent ? 1 : 0)
    data.append('language_id', language)

    let userLanguage = {}
    getState().language.language
      ? (userLanguage = getState().language.language.data)
      : null
    if (!file) {
      alert(userLanguage.alerts ? userLanguage.alerts.select_file : null)
      return
    }
    if (
      file &&
      !file.type.includes('application') &&
      !file.type.includes('text')
    ) {
      alert(
        'The type of this file is not supported, please try to upload a file like pdf, excel, word or text document.'
      )
      return
    }

    dispatch({ type: types.UPLOAD_FILE_STATUS, status: 'started' })

    axios
      .post(
        `${clientBaseUrl()}/courses/${course_id}/files?token=${getToken()}`,
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )

            dispatch({ type: types.FILE_UPLOAD_PERCENT, percent })
          },
        }
      )
      .then(() => {
        dispatch({ type: types.UPLOAD_FILE_STATUS, status: '' })
        dispatch(toggleUploadFilePage(false))
        dispatch(fetchCourse(course_id, language))
        dispatch({ type: types.FILE_UPLOAD_PERCENT, percent: 0 })
        dispatch({ type: types.SET_TEXT_TITLE, title: '' })
        dispatch(fetchContents(course_id, language))
        dispatch({ type: types.SET_REQUIRED, requiredContent: true })
      })
  }
}

export const editFile = (index) => {
  return (dispatch) => {
    dispatch(index === -1 ? undo() : present())
    dispatch({ type: types.EDIT_FILE, index })
  }
}

export const onCancel = () => {
  return (dispatch, getState) => {
    const { id } = getState().courses
    dispatch(fetchContents(id))
  }
}

export const deleteFile = (fileId) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (confirm(language.alerts ? language.alerts.delete_file_confirm : null)) {
      const { course_id } = getState().courses
      AxiosInstance.delete(
        `/courses/${course_id}/contents/${parseInt(fileId)}`
      ).then((id) => dispatch(fetchContents(id)))
    }
  }
}

export const updateFile = (value, id) => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const fileContent = content.find((item) => item.id === parseInt(id))
    const oldContent = content.filter((item) => item !== fileContent)

    fileContent.content[0].name = value

    const newContent = [...oldContent, fileContent]

    dispatch({ type: types.UPDATE_FILE, content: newContent })
  }
}

export const updateFileContent = (fileId) => {
  return (dispatch, getState) => {
    const { content, title, language } = getState().courses

    const contentItem = content.find((item) => item.id === parseInt(fileId))
    const contentItemIndex = content.findIndex(
      (item) => item.id === parseInt(fileId)
    )

    let data = {
      id: parseInt(fileId),
      content: JSON.stringify(contentItem.content),
      required: contentItem.required,
      type: 4,
      position: contentItem.position,
      title,
      language_id: language,
    }

    if (contentItemIndex !== -1) {
      dispatch(setContentLoading(true))
      const newContent = [
        ...content.slice(0, contentItemIndex),
        data,
        ...content.slice(contentItemIndex + 1),
      ]

      dispatch(saveContent(data))
      dispatch({ type: types.SET_CONTENTS, data: newContent })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
    }
  }
}

export const fetchCourses = (setProgress = false) => {
  return (dispatch) => {
    dispatch({ type: types.SET_FETCHED_ALL_COURSES, payload: false })

    AxiosInstance.get(`/courses`).then((data) => {
      dispatch({ type: types.COURSE_ALL, data })

      if (setProgress && Array.isArray(data)) {
        dispatch({ type: types.PROGRESS, data })
      }

      dispatch({ type: types.SET_FETCHED_ALL_COURSES, payload: true })
    })
  }
}

export const editScorm = (index) => {
  return (dispatch) => {
    dispatch(index === -1 ? undo() : present())
    dispatch({ type: types.EDIT_SCORM, index })
  }
}

export const updateScorm = (value, id) => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const scormContent = content.find((item) => item.id === parseInt(id))
    const oldContent = content.filter((item) => item !== scormContent)

    scormContent.content[0].name = value

    const newContent = [...oldContent, scormContent]

    dispatch({ type: types.UPDATE_SCORM, content: newContent })
  }
}

export const updateScormContent = (scormId) => {
  return (dispatch, getState) => {
    const { content, title, language } = getState().courses

    const contentItem = content.find((item) => item.id === parseInt(scormId))
    const contentItemIndex = content.findIndex(
      (item) => item.id === parseInt(scormId)
    )

    let data = {
      id: parseInt(scormId),
      content: JSON.stringify(contentItem.content),
      required: contentItem.required,
      type: 8,
      position: contentItem.position,
      title,
      language_id: language,
    }

    if (contentItemIndex !== -1) {
      dispatch(setContentLoading(true))
      const newContent = [
        ...content.slice(0, contentItemIndex),
        data,
        ...content.slice(contentItemIndex + 1),
      ]

      dispatch(saveContent(data))
      dispatch({ type: types.SET_CONTENTS, data: newContent })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
    }
  }
}

export const uploadScorm = (event) => {
  return (dispatch, getState) => {
    event.preventDefault()

    const { course_id, uploadScormStatus, requiredContent, title, language } =
      getState().courses

    if (uploadScormStatus === 'started') {
      return
    }
    const nodes = event.target.elements
    const fileInput = [].filter.call(nodes, (item) => item.type === 'file')[0]

    const type = 8
    const file = fileInput.files[0]

    const data = new FormData()

    data.append('file', file)
    data.append('title', title)
    data.append('type', type)
    data.append('required', requiredContent ? 1 : 0)
    data.append('language_id', language)

    let userLanguage = {}
    getState().language.language
      ? (userLanguage = getState().language.language.data)
      : null
    if (!file) {
      alert(userLanguage.alerts ? userLanguage.alerts.select_file : null)
      return
    }

    dispatch({ type: types.UPLOAD_SCORM_STATUS, status: 'started' })

    axios
      .post(
        `${clientBaseUrl()}/courses/${course_id}/scorm?token=${getToken()}`,
        data,
        {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )

            dispatch({ type: types.UPLOAD_SCORM_PERCENT, percent })
          },
        }
      )
      .then(() => {
        dispatch({ type: types.UPLOAD_SCORM_STATUS, status: '' })
        dispatch(toggleUploadScormPage(false))
        dispatch(fetchCourse(course_id, language))
        dispatch({ type: types.UPLOAD_SCORM_PERCENT, percent: 0 })
        dispatch(fetchContents(course_id, language))
        dispatch({ type: types.SET_TEXT_TITLE, title: '' })
        dispatch({ type: types.SET_REQUIRED, requiredContent: true })
      })
  }
}

export const setLastPathname = (value) => ({
  type: types.SET_LAST_PATHNAME,
  payload: value,
})

export const deleteScorm = (scormId) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_scorm_confirm : null)
    ) {
      const { course_id } = getState().courses
      AxiosInstance.delete(
        `/courses/${course_id}/contents/${parseInt(scormId)}`
      ).then(() => dispatch(fetchContents(course_id)))
    }
  }
}

export const selectVideo = (event) => {
  return (dispatch) => {
    const value = typeof event === 'string' ? event : event.target.value

    dispatch({ type: types.SELECT_VIDEO_TYPE, value })
  }
}

export const reorderContainers = (currentIndex, nextIndex) => {
  return (dispatch, getState) => {
    const { course_id, content } = getState().courses

    const firstItem = content.find((item) => item.position === currentIndex)
    const secondItem = content.find((item) => item.position === nextIndex)

    const newContent = [
      ...content.find((item) =>
        item === firstItem ? (item.position = nextIndex) : null
      ),
      ...content.find((item) =>
        item === secondItem ? (item.position = currentIndex) : null
      ),
      ...content,
    ]

    dispatch({ type: types.UPDATE_CONTENT, newContent: newContent })

    let data = content.map((item) => {
      return {
        id: item.id,
        position: item.position,
      }
    })

    AxiosInstance.post(`/courses/${course_id}/contents/reorder`, {
      positions: data,
    })
  }
}

export const reorderCourseContent = (oldIndex, newIndex) => {
  return (dispatch, getState) => {
    const { course_id, content, language } = getState().courses

    const newContent = [
      ...content.slice(0, oldIndex),
      ...content.slice(oldIndex + 1),
    ]

    newContent.splice(newIndex, 0, content[oldIndex])

    newContent.map((item, index) => (item.position = index + 1))

    let data = newContent.map((item, index) => {
      return {
        id: item.id,
        position: index + 1,
      }
    })

    dispatch({ type: types.UPDATE_CONTENT, newContent: newContent })

    AxiosInstance.post(`/courses/${course_id}/contents/reorder`, {
      positions: data,
      language_id: language,
    })
  }
}

export const handleOrder = () => {
  return (dispatch, getState) => {
    const { containerPosition, content } = getState().courses
    const contentTypes = content.map((item) => item.type)
    const containerTypes = containerPosition.map((item) => item.type)
    const mergeTypes = [...containerTypes, ...contentTypes]
    const newContainerTypes = mergeTypes.filter(
      (item, index, arr) => index === arr.indexOf(item)
    )
    const newContainers = newContainerTypes.map(
      (item) => defaultContainerPosition[item]
    )

    dispatch({ type: types.REORDER_CONTAINERS, containers: newContainers })
  }
}

export const addTextContainer = () => {
  return (dispatch, getState) => {
    const { id, course_id, newTextContent, requiredContent, title, language } =
      getState().courses

    const data = {
      type: 1,
      html: newTextContent,
      required: requiredContent ? 1 : 0,
      title,
      language_id: language,
    }

    console.log('leart2226', title, newTextContent)

    if (isTextEmpty(title)) {
      alert('Please enter title')
      return
    }

    // if (isTextEmpty(newTextContent)) {
    //   alert('Please enter some text')
    //   return
    // }

    AxiosInstance.post(`/courses/${course_id}/text`, data).then(() => {
      dispatch(fetchContents(course_id, language))
      dispatch({ type: types.SET_REQUIRED, requiredContent: true })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
      history.push(`/course/${course_id}/edit`)
    })
  }
}
export const addSubtitleContainer = () => {
  return (dispatch, getState) => {
    const { id, course_id, title, language } = getState().courses

    const data = {
      type: 0,
      title,
      language_id: language,
    }
    AxiosInstance.post(`/courses/${course_id}/text`, data).then(() => {
      dispatch(fetchContents(course_id, language))
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
      history.push(`/course/${course_id}/edit`)
    })
  }
}

export const onChangeText = (property, value) => {
  return (dispatch) => {
    if (property === 'textContent') {
      dispatch({ type: types.SET_TEXT_CONTENT, value })
    }
  }
}

export const saveTextContent = (contentId) => {
  return (dispatch, getState) => {
    const { textContent, content, title, language } = getState().courses

    const contentItem = content.find((item) => item.id === parseInt(contentId))
    const contentItemIndex = content.findIndex(
      (item) => item.id === parseInt(contentId)
    )

    let data = {
      id: parseInt(contentId),
      title: title,
      html: textContent,
      type: 1,
      required: contentItem.required,
      position: contentItem.position,
      language_id: language,
    }
    if (contentItemIndex !== -1) {
      dispatch(setContentLoading(true))
      const newContent = [
        ...content.slice(0, contentItemIndex),
        data,
        ...content.slice(contentItemIndex + 1),
      ]

      dispatch(saveContent(data))
      dispatch({ type: types.SET_CONTENTS, data: newContent })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
    }
  }
}
export const saveSubtitleContent = (contentId) => {
  return (dispatch, getState) => {
    const { content, title, language } = getState().courses

    const contentItem = content.find((item) => item.id === parseInt(contentId))
    const contentItemIndex = content.findIndex(
      (item) => item.id === parseInt(contentId)
    )

    let data = {
      id: parseInt(contentId),
      title,
      type: 0,
      position: contentItem.position,
      language_id: language,
    }
    if (contentItemIndex !== -1) {
      dispatch(setContentLoading(true))
      const newContent = [
        ...content.slice(0, contentItemIndex),
        data,
        ...content.slice(contentItemIndex + 1),
      ]

      dispatch(saveContent(data))
      dispatch({ type: types.SET_CONTENTS, data: newContent })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
    }
  }
}

export const handleText = () => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const textContent = content.filter((item) => item.type === 1)

    if (textContent[0]) {
      const html = textContent[0].html

      if (html) {
        dispatch({ type: types.SET_TEXT_CONTENT, value: html })
      } else {
        const textJSON = textContent[0].content[0].textContent

        if (textJSON) {
          const parse = JSON.parse(textJSON)

          dispatch({
            type: types.SET_TEXT_CONTENT,
            value: convertFromRaw(parse).getPlainText(),
          })
        } else {
          dispatch({ type: types.SET_TEXT_CONTENT, value: '' })
        }
      }
    } else {
      dispatch({ type: types.SET_TEXT_CONTENT, value: '' })
    }
  }
}

export const handleHtml = () => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const html = content.filter((item) => item.type === 5)

    if (html[0]) {
      const value = html[0].html

      if (value) {
        dispatch({ type: types.SET_HTML_CONTENT, value })
      }
    } else {
      dispatch({ type: types.SET_HTML_CONTENT, value: '' })
    }
  }
}

export const fetchUserProgress = () => {
  return (dispatch) => {
    AxiosInstance.get('/users/self/progress').then((data) => {
      if (Array.isArray(data)) {
        dispatch({ type: types.SET_USER_PROGRESS, data })
        dispatch(setCompletedCoursesFetched(true))
        dispatch(setCompletedCoursesData({ loading: false }))
      }
    })
  }
}

export const fetchUserProgressByCourseId = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/users/self/progress/${id}`).then((data) => {
      if (data) {
        dispatch({ type: types.SET_CURRENT_COURSE, data })
      }
    })
  }
}

export const toggleContentQuizPassPercentage = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_CONTENT_QUIZ_PASS_PERCENTAGE })
  }
}
export const setContentQuizPassPercentage = (value) => {
  return (dispatch) => {
    if (value.length <= 3 && value <= 100) {
      if (!value || value.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_CONTENT_QUIZ_PASS_PERCENTAGE, value })
      }
    }
    dispatch(saveCourse())
  }
}

export const setCountContentQuiz = (value) => {
  return (dispatch) => {
    if (value.length <= 3) {
      if (!value || value.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_COUNT_CONTENT_QUIZ, value })
      }
    }
  }
}
export const toggleContentQuizQuizTimer = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_CONTENT_QUIZ_TIMER })
  }
}
export const toggleConten = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_CONTENT_QUIZ_RANDOMIZE_ORDER })
  }
}

export const onChangeOptionContentQuiz = (index, property, value) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options } = questions[activeIndex]

    const newOptions = [
      ...options.slice(0, index),
      { ...options[index], [property]: value },
      ...options.slice(index + 1),
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}
export const selectContentQuizQuestion = (event) => {
  return (dispatch, getState) => {
    const { questions } = getState().courses.contentQuiz

    let randomId = randomString()

    const match = [
      { name: '', type: 1, id: randomId, selected: '' },
      { name: '', type: 2, id: randomString(), match: randomId },
    ]

    let value

    if (event.target && event.target.value !== undefined) {
      value = parseInt(event.target.value)
    } else if (event.option && event.option.value !== undefined) {
      value = parseInt(event.option.value)
    }

    const activeIndex = questions.length

    const options = (value === 1 ? bool : value === 5 ? match : multiple).map(
      (item) => (value === 5 ? { ...item } : { ...item, id: randomString() })
    )
    const newQuestions = [
      ...questions,
      {
        ...question,
        newQuestion: true,
        id: randomString(),
        type: value,
        options,
      },
    ]

    dispatch(presentContentQuiz())
    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
    dispatch({ type: types.SET_CONTENT_QUESTION_ACTIVE_INDEX, activeIndex })
  }
}

export const onChangeContentQuizQuestion = (property, value) => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], [property]: value },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}
export const presentContentQuiz = () => ({ type: types.PRESENT_CONTENT_QUIZ })
export const onChangeCheckbox = (nextOptionIndex) => {
  return (dispatch, getState) => {
    const { index, questions } = getState().courses.currentContentQuiz

    const options = questions[index].options

    const nextOptions = [
      ...options.slice(0, nextOptionIndex),
      {
        ...options[nextOptionIndex],
        selected: !options[nextOptionIndex].selected,
      },
      ...options.slice(nextOptionIndex + 1),
    ]

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], options: nextOptions },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.ANSWER, questions: nextQuestions })
    // dispatch(save())
  }
}
export const deleteQuestionContentQuiz = (index) => {
  return (dispatch, getState) => {
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      confirm(language.alerts ? language.alerts.delete_question_confirm : null)
    ) {
      const { questions } = getState().courses.contentQuiz

      const newQuestions = [
        ...questions.slice(0, index),
        ...questions.slice(index + 1),
      ]

      // dispatch({ type: types.QUESTION_ACTIVE_INDEX, activeIndex: -1 })
      dispatch({
        type: types.ON_CHANGE_CONTENT_QUESTION,
        questions: newQuestions,
      })
    }
  }
}

export const onChangeContentQuiz = (nextOptionIndex) => {
  return (dispatch, getState) => {
    const { index, questions } = getState().courses.currentContentQuiz
    const options = questions[index].options
    const optionIndex = options.findIndex((item) => item.selected)

    if (optionIndex === nextOptionIndex) {
      return
    }

    let nextOptions = options

    if (optionIndex !== -1) {
      const { selected, ...option } = options[optionIndex]

      nextOptions = [
        ...options.slice(0, optionIndex),
        option,
        ...options.slice(optionIndex + 1),
      ]
    }

    nextOptions = [
      ...nextOptions.slice(0, nextOptionIndex),
      { ...nextOptions[nextOptionIndex], selected: true },
      ...nextOptions.slice(nextOptionIndex + 1),
    ]

    const nextQuestions = [
      ...questions.slice(0, index),
      { ...questions[index], options: nextOptions },
      ...questions.slice(index + 1),
    ]

    dispatch({ type: types.ANSWER, questions: nextQuestions })
    // dispatch(save())
  }
}
export const onClick = (index) => {
  return (dispatch) => {
    dispatch({ type: types.ACTIVE_QUESTION, index })
  }
}
export const setContentQuizId = (id) => ({
  type: types.SET_CONTENT_QUIZ_ID,
  payload: id,
})
export const editContentQuestion = (activeIndex) => {
  return (dispatch) => {
    dispatch(presentContentQuiz())
    dispatch({ type: types.SET_CONTENT_QUESTION_ACTIVE_INDEX, activeIndex })
  }
}
export const setCurrentContentQuiz = (quiz) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_CURRENT_CONTENT_QUIZ, quiz })
    dispatch({ type: types.SET_RETRY_CURRENT_CONTENT_QUIZ, quiz })
  }
}

export const newContentQuiz = () => {
  return (dispatch, getState) => {
    const newContentQuiz = {
      title: '',
      index: 0,
      questions: [],
      activeIndex: -1,
      randomizeOrder: false,
      quizPassPercentage: 70,
      quizTimer: 0,
      isPassPercentageActive: false,
      isQuizTimerActive: false,
      passable: false,
    }
    dispatch({ type: types.SET_NEW_CONTENT_QUIZ, payload: newContentQuiz })
  }
}

export const setEmailFrequency = (value) => {
  return (dispatch, getState) => {
    const { id } = getState().courses

    dispatch({ type: types.SET_EMAIL_FREQUENCY, value })

    clearTimeout(timeout)

    if (id) {
      timeout = setTimeout(() => {
        dispatch(saveCourse())
      }, 700)
    }
  }
}

export const setExpireDate = (e) => {
  return (dispatch) => {
    const expireDate = e.target.value

    if (expireDate.length <= 2) {
      if (!expireDate || expireDate.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_EXPIRE_DATE, value: expireDate })
      }
    }
  }
}

export const onSubmitContentQuiz = (contentId) => {
  return (dispatch, getState) => {
    const {
      course_id,
      currentContentQuiz: { questions },
      contentQuizId,
    } = getState().courses
    // const { questions } = getState().currentContentQuiz

    const answered = []
    let language = {}
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    questions.map((item) => {
      if (
        item.type === 4 ||
        (item.options && item.options.filter((item) => item.selected).length)
      ) {
        answered.push(1)
      } else {
        answered.push(0)
      }
    })

    if (answered.includes(0)) {
      if (
        confirm(
          language.alerts
            ? language.alerts.submit_quiz_confirm_not_all_answers
            : null
        )
      ) {
        AxiosInstance.post(
          `/courses/${contentQuizId}/content-quiz-submissions`,
          {
            quiz: JSON.stringify(questions),
            quiz_status: last_questions_left ? 2 : 1,
          }
        ).then((data) => {
          if (!data.passable && data.quiz_passed > 0) {
            dispatch(finishContent(course_id, +contentQuizId))
          }

          dispatch(onClick(0))
          dispatch({
            type: types.SET_SUBMITED_CONTENT_QUIZ,
            payload: JSON.parse(data),
          })
          // dispatch(fetchSubmission(course_id))
          // dispatch({ type: types.SUBMIT_QUIZ, submitted: true })
        })
      }
    } else {
      if (
        confirm(language.alerts ? language.alerts.submit_quiz_confirm : null)
      ) {
        AxiosInstance.post(
          `/courses/${contentQuizId}/content-quiz-submissions`,
          {
            quiz: JSON.stringify(questions),
            // quiz_status: last_questions_left ? 2 : 1,
          }
        ).then((data) => {
          data = JSON.parse(data)

          if (!data.passable && data.quiz_passed > 0) {
            dispatch(finishContent(course_id, +contentQuizId))
          }

          dispatch(onClick(0))
          dispatch({
            type: types.SET_SUBMITED_CONTENT_QUIZ,
            payload: data,
          })
          // dispatch(fetchSubmission(course_id))
          // dispatch({ type: types.SUBMIT_QUIZ, submitted: true })
        })
      }
    }
  }
}
export const resetSubmitedContentQuiz = () => {
  return (dispatch, getState) => {
    const { retryCurrentContentQuiz } = getState().courses

    // apiNode.get(`courses/content-quiz/${contentQuizId}`).then((data) => {
    // 	// setQuiz(data)	props.setCurrentContentQuiz(data)

    // })
    dispatch({ type: types.SET_SUBMITED_CONTENT_QUIZ, payload: null })
    dispatch({
      type: types.SET_CURRENT_CONTENT_QUIZ,
      quiz: retryCurrentContentQuiz,
    })
  }
}
export const fetchContentQuizSubmission = (contentId, userId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(
      `/courses/content-quiz-submission?userId=${userId}&contentId=${contentId}`
    ).then((data) => {
      function isObjectEmpty(obj) {
        return Object.keys(obj).length === 0
      }

      let submissionObject

      if (isObjectEmpty(data)) {
        submissionObject = null
      } else {
        submissionObject = data
      }

      dispatch({
        type: types.SET_SUBMITED_CONTENT_QUIZ,
        payload: submissionObject,
      })
    })
  }
}

export const onChangeContentQuizName = (name) => {
  return (dispatch) => {
    dispatch({ type: types.SET_CONTENT_QUIZ_NAME, name })
  }
}
export const toggleContentQuizPassable = () => {
  return (dispatch) => {
    dispatch({ type: types.TOGGLE_CONTENT_QUIZ_PASSABLE })
  }
}
export const setContentQuizEditing = (quiz) => {
  // return
  const contentQuiz = quiz.content[0]

  contentQuiz.title = quiz.title
  contentQuiz.editing = true
  contentQuiz.id = quiz.id
  return (dispatch) => {
    dispatch({ type: types.SET_CONTENT_QUIZ_EDITING, payload: contentQuiz })
  }
}
export const saveContentQuiz = () => {
  return (dispatch, getState) => {
    const { id, course_id, requiredContent, title, language, contentQuiz } =
      getState().courses

    const data = {
      type: 10,
      html: null,
      required: requiredContent ? 1 : 0,
      title,
      language_id: language,
      ...contentQuiz,
    }

    // return`${baseURLNode()}/themes?token=${accessToken()

    // axios
    // .post(baseUrl() + `/courses/${course_id}/files`, data, {
    // 	onUploadProgress: (progressEvent) => {
    // 		const percent = Math.round(
    // 			(progressEvent.loaded * 100) / progressEvent.total
    // 		)
    // 		console.log(percent, 'percent')
    // 		dispatch({ type: types.VIDEO_UPLOAD_PERCENT, percent })
    // 	},
    // 	headers: {
    // 		Authorization: `Bearer ${localStorage.getItem('token')}`,
    // 	},
    // })

    axios
      .post(clientBaseUrl() + `/courses/${course_id}/content-quiz`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })
      .then((data) => {
        const contentQuiz = {
          title: '',
          index: 0,
          questions: [],
          activeIndex: -1,
          randomizeOrder: false,
          quizPassPercentage: 70,
          quizTimer: 0,
          isPassPercentageActive: false,
          isQuizTimerActive: false,
          passable: false,
        }

        dispatch({ type: types.SET_CONTENT_QUIZ, payload: contentQuiz })
        dispatch(fetchContents(course_id, language))
        dispatch({ type: types.SET_REQUIRED, requiredContent: true })
        dispatch({ type: types.SET_TEXT_TITLE, title: '' })
      })
  }
}
export const undoContentQuiz = () => ({ type: types.UNDO_CONTENT_QUIZ })
export const addOptionContentQuiz = () => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options } = questions[activeIndex]
    let newOptions = []
    let randomId = randomString()

    questions[activeIndex].type === 5
      ? (newOptions = [
          ...options,
          { name: '', id: randomId, type: 1, selected: '' },
          { name: '', id: randomString(), type: 2, match: randomId },
        ])
      : (newOptions = [
          ...options,
          { name: '', value: randomNumber(), id: randomString() },
        ])

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}
export const addDistractionContentQuiz = () => {
  return (dispatch, getState) => {
    const { activeIndex, questions } = getState().courses.contentQuiz
    const { options } = questions[activeIndex]
    let newOptions = []
    newOptions = [
      ...options,
      { name: '', value: randomNumber(), id: randomString(), type: 3 },
    ]

    const newQuestions = [
      ...questions.slice(0, activeIndex),
      { ...questions[activeIndex], options: newOptions },
      ...questions.slice(activeIndex + 1),
    ]

    dispatch({
      type: types.ON_CHANGE_CONTENT_QUESTION,
      questions: newQuestions,
    })
  }
}

export const setUserProgress = (courseId, status, fetchProgress = true) => {
  return (dispatch) => {
    AxiosInstance.post('/users/self/progress', {
      status,
      courseId,
    }).then(() => {
      if (fetchProgress) {
        dispatch(fetchUserProgressByCourseId(courseId))
        dispatch(fetchUserProgress())
      }
    })
  }
}

export const onVideoEnd = (video) => {
  console.log('leart2969', video)
  return (dispatch, getState) => {
    const courseId = getState().courses.id

    AxiosInstance.post('/tracking', {
      content_id: video.id,
      course_id: courseId,
      tracking: JSON.stringify(video.tracking),
    })
    dispatch(finishContent(courseId, video.id))
  }
}

export const onVideoProgress = (video) => {
  console.log(video, 'leart3077')
  return (dispatch, getState) => {
    const courseId = getState().courses.id
    AxiosInstance.post('/tracking', {
      content_id: video.id,
      course_id: courseId,
      tracking: JSON.stringify(video.tracking),
    })
  }
}

export const fetchTracking = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/tracking?courseId=${id}`).then((data) => {
      // dispatch({ type: types.SET_TRACKING_DATA_REWATCH, data })
      if (Array.isArray(data)) {
        dispatch({ type: types.SET_TRACKING_DATA, data })
      }
    })
  }
}

export const fetchTrackingByCourseContent = (courseId, contentId) => {
  return (dispatch) => {
    AxiosInstance.get(
      `/tracking?courseId=${courseId}&contentId=${contentId}`
    ).then((data) => {
      dispatch({ type: types.SET_TRACKING_DATA_REWATCH, data })
    })
  }
}
export const fetchTrackingByCourseContentScorm = (courseId, contentId) => {
  return (dispatch) => {
    AxiosInstance.get(
      `/tracking?courseId=${courseId}&contentId=${contentId}`
    ).then((data) => {
      dispatch({ type: types.SET_SUSPEND_DATA, suspendData: data.data })
    })
  }
}

export const selectCourseGroup = (groups) => {
  return (dispatch) => {
    dispatch({ type: types.SLECT_COURSE_GROUPS, groups })
    // dispatch(saveCourse())
  }
}

export const fetchCourseGroups = (courseId) => {
  return (dispatch) => {
    AxiosInstance.get(`/groups/courses/${courseId}`).then((data) => {
      if (Array.isArray(data)) {
        dispatch(selectCourseGroup(data))
      }
    })
  }
}

let reorderQuestionsTimeout = 0

export const reorderQuizzess = (quizzes) => {
  return (dispatch) => {
    dispatch({ type: types.REORDER_QUIZZES, questions: quizzes })

    clearTimeout(reorderQuestionsTimeout)

    reorderQuestionsTimeout = setTimeout(() => {
      dispatch(saveCourse())
    }, 1000)
  }
}

// Post HTML content to the server
export const saveHtml = (contentId) => {
  return (dispatch, getState) => {
    const { html, content, title, language } = getState().courses
    const contentItem = content.find((item) => item.id === parseInt(contentId))
    const contentItemIndex = content.findIndex(
      (item) => item.id === parseInt(contentId)
    )

    const data = {
      id: parseInt(contentId),
      type: 5,
      title,
      html,
      required: contentItem.required,
      position: contentItem.position,
      language_id: language,
    }
    if (contentItemIndex !== -1) {
      dispatch(setContentLoading(true))
      const newContent = [
        ...content.slice(0, contentItemIndex),
        data,
        ...content.slice(contentItemIndex + 1),
      ]

      dispatch(saveContent(data))
      dispatch({ type: types.SET_CONTENTS, data: newContent })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
    }
  }
}

export const addHtml = () => {
  return (dispatch, getState) => {
    const { course_id, html, requiredContent, title, language } =
      getState().courses
    const data = {
      type: 5,
      html,
      title,
      required: requiredContent ? 1 : 0,
      language_id: language,
    }

    if (isTextEmpty(title)) {
      alert('Title cannot be empty!')
      return
    }

    // if (isTextEmpty(html)) {
    //   alert('Please enter some HTML')
    //   return
    // }

    AxiosInstance.post(`/courses/${course_id}/text`, data).then(() => {
      dispatch(fetchContents(course_id, language))
      dispatch({ type: types.SET_REQUIRED, requiredContent: true })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
      history.push(`/course/${course_id}/edit`)
    })
  }
}

export const checkPDFSettings = () => {
  return (dispatch, getState) => {
    return getState().generalConfig.pdfViewer
  }
}

export const resetCourseProgress = (courseId) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_RESETTING_PROGRESS, payload: true })
    if (
      !confirm(
        "Are you sure you want to reset this course's progress for all users?"
      )
    ) {
      dispatch({ type: types.SET_RESETTING_PROGRESS, payload: false })
      return
    }

    AxiosInstance.delete(`/courses/${courseId}/reset-progress`).then(() => {
      dispatch({ type: types.SET_RESETTING_PROGRESS, payload: false })
    })
  }
}

export const setUserCertificationTime = (time, courseId) => {
  return (dispatch) => {
    AxiosInstance.post('/users/self/progress/time', {
      time,
      courseId,
    })
  }
}

export const cloneCourse = (id) => {
  return (dispatch) => {
    AxiosInstance.post(`/courses/${id}/clone`).then((data) => {
      dispatch(setCloneId(data.id))
      history.push(`/course/${data.id}/edit`)
    })
  }
}

export const fetchCourseAvailableLanguages = (id) => {
  return (dispatch, getState) => {
    const { languages } = getState().language

    AxiosInstance.get(`/courses/${id}/languages`).then((data) => {
      let courseAvailableItems = []
      if (languages.length) {
        languages.map((item) =>
          data.includes(item.id) ? courseAvailableItems.push(item) : null
        )
      }
      dispatch({
        type: types.SET_COURSE_AVAILABLE_LANGUAGES,
        value: courseAvailableItems,
      })
      dispatch({
        type: types.SET_AVAILABLE_LANGUAGES_OPTIONS,
        value: courseAvailableItems,
      })
    })
  }
}

export const setCourseLanguage = (event) => {
  return (dispatch, getState) => {
    const { course_id } = getState().courses
    const languageId = event.hasOwnProperty('target')
      ? event.target.value
      : event[0]?.option?.value

    dispatch({ type: types.SET_COURSE_LANGUAGE, language: languageId })
    dispatch(fetchCourse(course_id, languageId))
    dispatch(fetchContents(course_id, languageId))
  }
}

export const fetchAllKeywords = (data) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/courses/keywords`).then((data) => {
      const availableKeywords = data.length
        ? data.map((item) => {
            return {
              id: item,
              name: item,
            }
          })
        : []

      dispatch({
        type: types.SET_AVAILABLE_KEYWORDS,
        value: availableKeywords,
      })
    })
  }
}

export const setDetailCourseLanguage = (event) => {
  return (dispatch) => {
    const languageId = event.target.value
    dispatch({ type: types.SET_COURSE_LANGUAGE, language: languageId })
  }
}

export const setEquivalentCourse = (value) => {
  return (dispatch) => {
    if (value) {
      const equivalentCourseId = value.option.id
      dispatch({
        type: types.SET_EQUIVALENT_COURSE,
        value: equivalentCourseId,
      })
    } else {
      dispatch({ type: types.SET_EQUIVALENT_COURSE, value: null })
    }
    dispatch(saveCourse())
  }
}

export const setKeywords = (keywords) => {
  return (dispatch, getState) => {
    const { availableKeywords, id } = getState().courses

    const nextKeywords = keywords.__isNew__keywords
      ? keywords.map((word) => {
          return {
            id: word.value,
            name: word.value,
          }
        })
      : keywords.map((word) => {
          return {
            id: word.value,
            name: word.value,
          }
        })

    const nextAvailableKeywords = availableKeywords

    nextKeywords.filter((item) => {
      !nextAvailableKeywords.find((subItem) => subItem.name === item.name)
        ? nextAvailableKeywords.push(item)
        : null
    })

    dispatch({
      type: types.SET_AVAILABLE_KEYWORDS,
      value: nextAvailableKeywords,
    })
    dispatch({ type: types.SET_KEYWORDS, value: nextKeywords })

    dispatch(saveCourse())
  }
}

export const setContentRequired = (id) => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const courseContent = content.find((item) => item.id === parseInt(id))
    const filteredContent = content.filter((item) => item.id !== id)

    courseContent.required === 1
      ? (courseContent.required = 0)
      : (courseContent.required = 1)

    const newContent = [...filteredContent, courseContent]

    dispatch({ type: types.SET_REQUIRED_CONTENT, newContent: newContent })
  }
}

export const setRequired = () => {
  return (dispatch, getState) => {
    const { requiredContent } = getState().courses
    dispatch({
      type: types.SET_REQUIRED,
      requiredContent: !requiredContent,
    })
  }
}

export const setRestrictVideo = () => {
  return (dispatch, getState) => {
    const { restricVideo } = getState().courses
    dispatch({ type: types.SET_RESTRICT_VIDEO, payload: !restricVideo })
  }
}

export const setRedirectUrl = (value) => {
  return (dispatch) => {
    dispatch({ type: types.SET_REDIRECT_URL, value })
    dispatch(saveCourse())
  }
}

export const setCertificateFooterContent = (value) => {
  return (dispatch, getState) => {
    const { course_id } = getState().courses
    dispatch({ type: types.SET_CERTIFICATE_FOOTER_CONTENT, value })

    clearTimeout(timeout)

    if (course_id) {
      timeout = setTimeout(() => {
        dispatch(saveCourse())
      }, 700)
    }
  }
}

export const setRetakeQuizCount = (value) => {
  return (dispatch) => {
    if (value.length <= 2) {
      if (!value || value.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_RETAKE_QUIZ_COUNT, value })
      }
    }
    dispatch(saveCourse())
  }
}

export const setPassPercentage = (value) => {
  return (dispatch) => {
    if (value.length <= 3 && value <= 100) {
      if (!value || value.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_QUIZ_PASS_PERCENTAGE, value })
      }
    }
    dispatch(saveCourse())
  }
}
export const setCount = (value) => {
  return (dispatch) => {
    // Convert the value to a number for easier validation
    const numericValue = Number(value)

    // Check if the numeric value is within the acceptable range
    if (numericValue >= 0 && numericValue <= 59) {
      dispatch({ type: types.SET_COUNT, value: numericValue })
    }

    // Ensure the value is saved regardless
    dispatch(saveCourse())
  }
}
export const setQuestionsPerDays = (value) => {
  return (dispatch) => {
    if (value.length <= 3) {
      if (!value || value.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_QUESTIONS_PER_DAYS, value })
      }
    }
    dispatch(saveCourse())
  }
}
export const setDaysPerQuestions = (value) => {
  return (dispatch) => {
    if (value.length <= 3) {
      if (!value || value.match(/^\d{1,}(^\.)?$/)) {
        dispatch({ type: types.SET_DAYS_PER_QUESTIONS, value })
      }
    }
    dispatch(saveCourse())
  }
}
export const setQuizStartDate = (value) => {
  return (dispatch) => {
    // const quizStartDate = Date.parse(value)
    dispatch({ type: types.SET_QUIZ_START_DATE, quizStartDate: value })
    dispatch(saveCourse())
  }
}

export const setCourseAvailableLanguages = (value) => {
  return (dispatch, getState) => {
    const { id } = getState().courses

    const addedLanguage =
      value === null ? '' : value.length > 1 && value[value.length - 1].option

    const addedLanguages = value === null ? '' : value.map((val) => val.option)

    // const addedLanguage = value && value.map((val) => val.option)

    if (addedLanguage) {
      const data = {
        language_id: addedLanguage.id,
      }
      AxiosInstance.post(`/courses/${id}/languages`, data).then(() => {
        dispatch({
          type: types.SET_COURSE_AVAILABLE_LANGUAGES,
          value: addedLanguages,
        })
        dispatch({
          type: types.SET_AVAILABLE_LANGUAGES_OPTIONS,
          value: getState().courses.courseAvailableLanguages,
        })
        dispatch(saveCourse())
      })
    }
  }
}

export const onChangeLanguageIsReady = () => {
  return (dispatch, getState) => {
    const { languageIsReady } = getState().courses
    languageIsReady === 1
      ? dispatch({ type: types.SET_LANGUAGE_READY, value: -1 })
      : dispatch({ type: types.SET_LANGUAGE_READY, value: 1 })

    dispatch(saveCourse())
  }
}

export const fetchAllCourses = () => {
  return (dispatch) => {
    AxiosInstance.get('/courses/all').then((data) => {
      if (Array.isArray(data)) {
        dispatch({ type: types.SET_ALL_COURSES, data: data })
      }
    })
  }
}

export const onChangeIsActiveCourse = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_COURSE_INACTIVE })
    dispatch(saveCourse())
  }
}

export const onSetExpirationDate = () => {
  return (dispatch, getState) => {
    console.log('leart3407')

    dispatch({ type: types.SET_EXPIRATION_DATE })
    dispatch(saveCourse())
  }
}

export const onResetExpirationDate = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.RESET_EXPIRATION_DATE })
  }
}

export const onChangeExpirationDate = () => {
  return (dispatch) => {
    console.log('leart3422')
    dispatch({ type: types.SET_EXPIRATION_DATE })
    // dispatch(saveCourse())
  }
}

export const onSetActiveExpirationDate = (value) => {
  return (dispatch) => {
    dispatch({ type: types.SET_ACTIVE_EXPIRATION_DATE, value })
  }
}

export const setExpirePeriod = (e) => {
  return (dispatch) => {
    const expirePeriod = e.target.value

    dispatch({ type: types.SET_EXPIRE_PERIOD, value: expirePeriod })
  }
}

export const onChangeSecondLevelApproval = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SECOND_LEVEL_APPROVAL })
    dispatch(saveCourse())
  }
}

export const onChangeChecklistType = (data) => {
  return (dispatch) => {
    dispatch({ type: types.SET_CHECKLIST_TYPE })
    dispatch(saveCourse())
  }
}

export const fetchCourseExistingContent = (languageId) => {
  return (dispatch) => {
    AxiosInstance.get(`/courses/all/contents/${languageId}`).then((data) => {
      let filterData = data.filter((item) => item.contents.length !== 0)
      filterData.sort((a, b) =>
        a.name.trim().toLowerCase() > b.name.trim().toLowerCase() ? 1 : -1
      )
      dispatch({
        type: types.SET_COURSE_EXISTING_CONTENT,
        filterData,
      })
      dispatch(setPaginationItems(filterData))
    })
  }
}

export const addExistingContent = (contentId, languageId) => {
  return (dispatch, getState) => {
    const { course_id, language } = getState().courses
    const data = {
      course_content_id: contentId,
      course_id,
      language_id: languageId,
    }
    AxiosInstance.post(`/courses/${course_id}/import`, data).then(() => {
      dispatch(fetchContents(course_id, language))
    })
  }
}

export const setSearchValueExistingContent = (searchValueExistingContent) => {
  return (dispatch, getState) => {
    const { existingContents } = getState().courses
    const filteredItems = existingContents.filter(
      (item) =>
        item.name
          .trim()
          .toLowerCase()
          .indexOf(searchValueExistingContent.toLowerCase()) !== -1
    )
    dispatch(setPaginationItems(filteredItems))
    dispatch({
      type: types.SET_SEARCH_VALUE_EXISTING_CONTENT,
      value: searchValueExistingContent,
    })
  }
}

export const setCourseOpen = (courseId) => {
  return (dispatch) => {
    AxiosInstance.post(`/courses/${courseId}/open`)
  }
}

export const showRewardOverlay = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_SHOW_CLAIM_REWARD })
  }
}

export const hideRewardOverlay = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_HIDE_CLAIM_REWARD })
    dispatch({ type: types.SET_EARNED_REWARDS_BADGES, data: [] })
    dispatch({ type: types.SET_EARNED_REWARDS_POINTS, data: null })
  }
}

export const onChangeLTI = (event) => {
  return (dispatch) => {
    const name = event.target.name
    const value = event.target.value
    dispatch({ type: types.SET_LTI_DATA, name, value })
  }
}

export const addLTI = () => {
  return (dispatch, getState) => {
    let languageLabel = {}
    getState().language.language
      ? (languageLabel = getState().language.language.data)
      : null
    const {
      title,
      type,
      requiredContent,
      launchUrl,
      consumerKey,
      sharedSecret,
      customParameters,
      course_id,
      language,
    } = getState().courses

    const data = {
      title,
      type: 9,
      language_id: language,
      required: requiredContent ? 1 : 0,
      launch_url: launchUrl,
      consumer_key: consumerKey,
      shared_secret: sharedSecret,
      custom_parameters: customParameters,
    }

    AxiosInstance.post(`/courses/${course_id}/lti`, data).then(() => {
      dispatch(fetchContents(course_id, language))
      dispatch({ type: types.SET_REQUIRED, requiredContent: true })
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
      dispatch({ type: types.SET_LAUNCH_URL, launchUrl: '' })
      dispatch({ type: types.SET_CONSUMER_KEY, consumerKey: '' })
      dispatch({ type: types.SET_CONSUMER_SECRET, sharedSecret: '' })
      dispatch({
        type: types.SET_CUSTOM_PARAMETERS,
        customParameters: '',
      })
      history.push(`/course/${course_id}/edit`)
    })
  }
}

export const fetchLtiContent = (contentId) => {
  return (dispatch, getState) => {
    const { content } = getState().courses
    const currentContent = content.find(
      (item) => item.id === parseInt(contentId)
    )

    if (currentContent) {
      dispatch({
        type: types.SET_TEXT_TITLE,
        title: currentContent.title,
      })
      const contentDetails = currentContent.content[0]
        ? currentContent.content[0]
        : currentContent.content
      if (contentDetails) {
        dispatch({ type: types.SET_LTI_PARAMS, params: contentDetails })
        dispatch({
          type: types.SET_LAUNCH_URL,
          launchUrl: contentDetails.launch_url,
        })
        dispatch({
          type: types.SET_CONSUMER_KEY,
          consumerKey: contentDetails.consumer_key,
        })
        dispatch({
          type: types.SET_CONSUMER_SECRET,
          sharedSecret: contentDetails.shared_secret,
        })
        dispatch({
          type: types.SET_CUSTOM_PARAMETERS,
          customParameters: contentDetails.custom_parameters,
        })
      }
    }
  }
}

export const saveLTI = (ltiId) => {
  return (dispatch, getState) => {
    let languageLabel = {}
    getState().language.language
      ? (languageLabel = getState().language.language.data)
      : null
    const {
      content,
      title,
      language,
      launchUrl,
      consumerKey,
      sharedSecret,
      customParameters,
      course_id,
    } = getState().courses

    if (!title) {
      alert(
        languageLabel.alerts ? languageLabel.alerts.lti_title_not_empty : null
      )
      return
    }
    if (!launchUrl) {
      alert(
        languageLabel.alerts
          ? languageLabel.alerts.lti_launch_url_not_empty
          : null
      )
      return
    }
    if (!consumerKey) {
      alert(
        languageLabel.alerts
          ? languageLabel.alerts.lti_consumer_key_not_empty
          : null
      )
      return
    }
    if (!sharedSecret) {
      alert(
        languageLabel.alerts
          ? languageLabel.alerts.lti_shared_secret_not_empty
          : null
      )
      return
    }

    const contentItem = content.find((item) => item.id === parseInt(ltiId))
    const contentItemIndex = content.findIndex(
      (item) => item.id === parseInt(ltiId)
    )
    const ltiContent = {
      launch_url: launchUrl,
      consumer_key: consumerKey,
      shared_secret: sharedSecret,
      custom_parameters: customParameters,
    }
    let data = {
      id: parseInt(ltiId),
      content: JSON.stringify(ltiContent),
      required: contentItem.required,
      type: 9,
      position: contentItem.position,
      title,
      language_id: language,
    }

    if (contentItemIndex !== -1) {
      dispatch(setContentLoading(true))
      const newContent = [
        ...content.slice(0, contentItemIndex),
        data,
        ...content.slice(contentItemIndex + 1),
      ]
      dispatch(saveContent(data))
      dispatch({ type: types.SET_CONTENTS, data: newContent })
      dispatch(fetchContents(course_id, language))
      dispatch({ type: types.SET_TEXT_TITLE, title: '' })
      dispatch({ type: types.SET_LAUNCH_URL, launchUrl: '' })
      dispatch({ type: types.SET_CONSUMER_KEY, consumerKey: '' })
      dispatch({ type: types.SET_CONSUMER_SECRET, sharedSecret: '' })
      dispatch({
        type: types.SET_CUSTOM_PARAMETERS,
        customParameters: '',
      })
    }
  }
}

export const submitLtiForm = (params, contendId) => {
  return (dispatch, getState) => {
    event.preventDefault()
    const courseId = getState().courses.id
    const courseName = getState().courses.name

    const { id, access, first_name, last_name, email } = getState().auth.user

    const timestamp = Math.round(Date.now() / 1000)
    const contentId = contendId
    const formatedParams = {
      lti_message_type: 'basic-lti-launch-request',
      lti_version: 'LTI-1p0',
      resource_link_id: 'resourceLinkId',
      oauth_consumer_key: params.consumer_key,
      oauth_nonce: btoa(timestamp),
      oauth_signature_method: 'HMAC-SHA1',
      oauth_timestamp: timestamp,
      oauth_callback: '',
      oauth_version: '1.0',
      user_id: id,
      roles: access === 1 ? 'Instructor' : 'Learner',
      resource_link_description: '',
      lis_person_name_full: `${first_name} ${last_name}`,
      lis_person_name_family: last_name,
      lis_person_name_given: first_name,
      lis_person_sourcedid: `${id}|${courseId}345`,
      lis_outcome_service_url: `/users/self/course-content-finished-lti&course_id=${courseId}&content_id=${contentId}`,
      lis_result_sourcedid: `${id}.${courseId}`,
      context_id: courseId,
      context_title: courseName,
      resource_link_title: '',
      context_label: '',
      tool_consumer_instance_guid: '',
      tool_consumer_instance_name: '',
    }

    const signature = oauthSign.hmacsign(
      'POST',
      params.launch_url,
      formatedParams,
      params.shared_secret
    )
    formatedParams.oauth_signature = signature

    const ltiForm = document.getElementById('ltiForm')

    Object.entries(formatedParams).map((item) => {
      const inputElement = document.createElement('INPUT')
      inputElement.setAttribute('type', 'hidden')
      inputElement.setAttribute('name', item[0])
      inputElement.setAttribute('value', item[1])
      ltiForm.appendChild(inputElement)
    })

    ltiForm.action = params.launch_url

    document.forms['ltiForm'].submit()
  }
}

export const onClickSearch = () => {
  return (dispatch, getState) => {
    const value = getState().courses.searchValue
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value })
  }
}
export const onSearchReset = () => {
  return (dispatch) => {
    dispatch({ type: types.SET_SEARCH_VALUE_ON_CLICK, value: '' })
    dispatch({ type: types.SET_SEARCH_VALUE, value: '' })
  }
}

export const onScormProgress = (contentId, suspendData) => {
  return async (dispatch, getState) => {
    const courseId = getState().courses.course_id
    const statusValue =
      suspendData && suspendData.value != null
        ? String(suspendData.value).toLowerCase()
        : ''

    if (
      suspendData &&
      (suspendData.type == 'quiz_failed' ||
        ((suspendData.type == 'success_status' ||
          suspendData.type == 'lesson_status') &&
          statusValue == 'failed'))
    ) {
      dispatch(setUserProgress(courseId, 2))
      return
    }

    if (suspendData.type == 'success_status' && statusValue == 'passed') {
      await dispatch(setUserProgress(courseId, 1))
      return
    }

    if (suspendData.type !== 'suspend_data') {
      return
    }

    console.log('leart3791', contentId, courseId, suspendData)

    AxiosInstance.post('/tracking', {
      content_id: contentId,
      course_id: courseId,
      tracking: JSON.stringify(suspendData),
    }).then((data) => {
      dispatch({
        type: types.SET_SUSPEND_DATA,
        suspendData: JSON.parse(data.progress),
      })
    })
  }
}

export const setSuspendDataOnMount = (data) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_SUSPEND_DATA, suspendData: data })
  }
}

export const resetSuspendDataOnMount = () => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_SUSPEND_DATA, suspendData: {} })
  }
}

export const toggleFeedbackOverlay = () => {
  return (dispatch, getState) => {
    const { isFeedbackOverlayShowing, selfCourseFeedbackData } =
      getState().courses

    dispatch({
      type: types.TOOGLE_FEEDBACK_OVERLAY,
      value: !isFeedbackOverlayShowing,
    })
    if (!selfCourseFeedbackData) {
      dispatch(setFeedbackTextboxActive(true))
    }
  }
}

export const setFeedbackTextboxActive = (isFeedbackTextboxActive) => {
  return (dispatch) => {
    dispatch({
      type: types.SET_FEEDBACK_TEXTBOX_ACTIVE,
      value: isFeedbackTextboxActive,
    })
  }
}

export const sendFeedbackData = (rating, feedback, course_id) => {
  const sendData = {
    feedback: feedback,
    rating: rating,
  }
  return (dispatch, getState) => {
    if (!rating || rating === 0) {
      alert('Please, leave a raiting!')
    } else {
      AxiosInstance.post(`/feedback/${course_id}`, sendData).then((data) => {
        dispatch(setAllFeedbackData(course_id))
        dispatch(getSelfCourseFeedbackData(course_id))
        dispatch(fetchCourseRating(course_id))
        dispatch(setFeedbackTextboxActive(false))
        toast.info('Feedback sent successfully!', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
      dispatch({
        type: types.SET_HIDE_FEEDBACKRATING,
        value: true,
      })
    }
  }
}

export const fetchCourseRating = (course_id) => {
  return (dispatch, getState) => {
    // const { course_id } = getState().courses
    AxiosInstance.get(`/feedback/course/averageCount/${course_id}`).then(
      (data) => {
        dispatch({ type: types.FETCH_COURSE_RATING, data })
      }
    )
  }
}

export const setAllFeedbackData = (id) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/feedback/course/all/${id}`).then((data) => {
      dispatch({ type: types.SET_FEEDBACK_DATA, feedbackData: data })
      dispatch({
        type: types.SET_RATING_DATA,
        value:
          data && data[data.length - 1] && data[data.length - 1].average_rating,
      })
    })
  }
}
export const getSelfCourseFeedbackData = (id) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/feedback/course/${id}`).then((data) => {
      dispatch({
        type: types.SET_SELF_COURSE_FEEDBACK_DATA,
        selfCourseFeedbackData: data,
      })
    })
  }
}

export const onChangeNote = (value) => ({
  type: types.SET_COURSE_NOTE,
  value,
})

export const saveNote = (note, course_id) => {
  const data = {
    note,
  }
  return (dispatch, getState) => {
    AxiosInstance.post(`/notes/${course_id}/note`, data).then((data) => {
      dispatch({ type: types.SET_COURSE_NOTE, value: data })
      dispatch(fetchCourseNotes())
      // toast.info("Note has been saved!", {
      //   position: toast.POSITION.BOTTOM_RIGHT,
      //   className: "general-settings-toast",
      //   autoClose: 4000,
      // });
    })
  }
}

export const fetchCourseNotes = () => {
  return (dispatch, getState) => {
    const { course_id } = getState().courses
    AxiosInstance.get(`/notes/${course_id}`).then((data) => {
      dispatch({ type: types.FETCH_COURSE_NOTE, data })
    })
  }
}

export const onChangeTrainingForm = (event) => {
  return (dispatch, getState) => {
    const { trainingType } = getState().courses
    const name = event.target.name
    const value = event.target.value
    if (trainingType === 'zoom') {
      dispatch({ type: types.ON_CHANGE_ZOOM, name, value })
    } else {
      dispatch({ type: types.ON_CHANGE_TRAINING_FORM, name, value })
    }
  }
}

export const onChangingTrainingThumb = (thumbFile) => {
  return (dispatch, getState) => {
    // const fileReader = new FileReader()
    // fileReader.onload = (evt) => {
    // 	dispatch({
    // 		type: types.TRAINING_THUMBNAIL,
    // 		trainingThumb: evt.target.result,
    // 	})
    // }

    // fileReader.readAsDataURL(thumbFile)
    dispatch({
      type: types.TRAINING_THUMBNAIL,
      trainingThumb: thumbFile,
      originalName: thumbFile.name,
    })
  }
}

export const onChangeTrainingType = (trainingType) => {
  return (dispatch) => {
    dispatch({ type: types.ON_CHANGE_TRAINING_TYPE, trainingType })
  }
}

export const onChangeTrainingInstructors = (event, changingItem) => {
  return (dispatch, getState) => {
    const { externalTrainingInstructors } = getState().courses
    let newOptionChanged = externalTrainingInstructors.find(
      (item) => item.id === changingItem.id
    )
    newOptionChanged = { ...newOptionChanged, name: event.target.value }
    let newOptions = externalTrainingInstructors.map((mapingItem) => {
      if (mapingItem.id === changingItem.id) {
        return newOptionChanged
      } else return mapingItem
    })

    dispatch({
      type: types.SET_TRAINING_INTRUCTORS,
      externalTrainingInstructors: newOptions,
    })
  }
}
export const addOptionInstructor = () => {
  return (dispatch, getState) => {
    const { externalTrainingInstructors } = getState().courses
    let newOptions = []
    let randomId = randomString()

    newOptions = [...externalTrainingInstructors, { id: randomId, name: '' }]
    dispatch({
      type: types.SET_TRAINING_INTRUCTORS,
      externalTrainingInstructors: newOptions,
    })
  }
}
export const removeOptionInstructor = (removingItem) => {
  return (dispatch, getState) => {
    const { externalTrainingInstructors } = getState().courses
    let newOptions = externalTrainingInstructors.filter(
      (item) => item.id !== removingItem.id
    )
    dispatch({
      type: types.SET_TRAINING_INTRUCTORS,
      externalTrainingInstructors: newOptions,
    })
  }
}

export const selectStore = (stores) => ({
  type: types.SELECT_STORES,
  selectedStoresTraining: stores,
})
export const selectUser = (users) => ({
  type: types.SELECT_USERS,
  selectedInternalTrainingInstructors: users,
})

export const saveTrainingSession = () => {
  // event.preventDefault()
  return (dispatch, getState) => {
    const {
      course_id,
      date,
      trDescription,
      durationHour,
      durationMin,
      trainingPeriod,
      time,
      timezone,
      topic,
      trainingType,
      selectedStoresTraining,
      selectedInternalTrainingInstructors,
      address,
      availableSeats,
      externalTrainingInstructors,
      trainingThumb,
      training,
    } = getState().courses
    const {
      assignableTrainingLocationGroups,
      assignableTrainingRoles,
      assignableTrainingStores,
      assignableTrainingUsers,
    } = getState().groups
    const trainingTopic =
      (topic && topic.trim()) || (training.topic && training.topic.trim())
    const start_time =
      date || time
        ? date + 'T' + time
        : training.date || training.time
        ? training.date + 'T' + training.time
        : ''
    const duration =
      +durationHour * 60 + +durationMin ||
      +training.durationHour * 60 + +training.durationMin
    const trainingTimezone = timezone || training.timezone
    const trainingDescription =
      (training.trDescription && training.trDescription.trim()) ||
      (trDescription && trDescription.trim())
    const selected_stores = selectedStoresTraining
    const trainingAddress = training.address || address
    const trainingAvailableSeats = training.availableSeats || availableSeats
    const trainers = [
      ...selectedInternalTrainingInstructors.map((item) => item.id),
    ]
    const users = assignableTrainingUsers
    const roles = assignableTrainingRoles.filter(
      (item, index) =>
        index === assignableTrainingRoles.findIndex((elem) => elem === item)
    )

    const groups = assignableTrainingLocationGroups
    const locations = assignableTrainingStores

    if (
      (durationHour && durationHour < 0) ||
      (training && training.durationHour < 0)
    ) {
      alert('Please put a valid duration hour')
      return
    }
    if (
      (durationMin && (durationMin < 0 || durationMin >= 60)) ||
      (training && training.durationMin < 0) ||
      training.durationMin >= 60
    ) {
      alert('Please put a valid duration minutes (between 0 and 59)')
      return
    }
    if (!trainingTopic) {
      alert('Please write the event name')
      return
    }
    if (!trainingType) {
      alert('You have to pick one of training session type: Zoom or In Person')
      return
    }
    if (!start_time) {
      alert('You have to pick a start time for this training')
      return
    }
    if (!duration || duration === '0') {
      alert('Please put the duration of the training')
      return
    }
    if (trainingType === 'in-person') {
      if (!selectedInternalTrainingInstructors.length) {
        alert('Please pick at least one training instructor')
        return
      }
    }

    const formData = new FormData()
    formData.append('topic', trainingTopic)
    formData.append('start_time', start_time)
    formData.append('duration', duration)
    if (trainingTimezone) {
      formData.append('timezone', trainingTimezone)
    }
    if (trainingDescription) {
      formData.append('description', trainingDescription)
    }
    if (trainingThumb) {
      formData.append('image', trainingThumb)
    }
    if (trainingAddress) {
      formData.append('address', trainingAddress)
    }
    if (trainingAvailableSeats) {
      formData.append('available_seats', trainingAvailableSeats)
    }
    trainers.map((item, index) => {
      formData.append('trainers[' + index + ']', item)
    })
    if (users) {
      users.map((item, index) => {
        formData.append('users[' + index + ']', item)
      })
    }
    if (roles) {
      roles.map((item, index) => {
        formData.append('roles[' + index + ']', item)
      })
    }
    if (groups) {
      groups.map((item, index) => {
        formData.append('groups[' + index + ']', item)
      })
    }
    if (locations) {
      locations.map((item, index) => {
        formData.append('locations[' + index + ']', item)
      })
    }

    if (trainingType === 'zoom') {
      AxiosInstance.post(
        `/courses/${course_id}/create/zoom`,
        topic,
        start_time,
        duration,
        timezone
      )
        .then((data) => {
          dispatch({ type: types.START_URL, value: data.start_url })
          toast.info('Zoom meeting has been created successfully!', {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'general-settings-toast',
            autoClose: 4000,
          })
        })
        .catch((error) => {
          if (error.response.data === "User hasn't authenticated with zoom") {
            alert(
              'You are not authorized with Zoom yet. You need to get authorized in Zoom first, in order to create the meeting.'
            )
          }
        })
    } else if (trainingType === 'in-person') {
      dispatch({ type: types.SET_LOADING_TRAINING, value: true })
      const courseId = getState().courses.id
      const trainingId =
        Object.keys(training).length !== 0 && training.trainingId
          ? training.trainingId
          : ''
      if (trainingId) {
        dispatch(updateTrainingSession(trainingId, formData))
      } else {
        AxiosInstance.post(`/training-session/${courseId}`, formData)
          .then((response) => {
            dispatch({
              type: types.SET_LOADING_TRAINING,
              value: false,
            })
            toast.info('The training has successfully been created', {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: 'general-settings-toast',
              autoClose: 4000,
            })
          })
          .catch(() => {
            toast.error(
              'Something went wrong with creating this training, please try again!',
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                className: 'general-settings-toast',
                autoClose: 4000,
              }
            )
          })
      }
    }
  }
}

export const updateTrainingSession = (trainingId, data) => {
  return (dispatch, getState) => {
    const courseId = getState().courses.id

    AxiosInstance.put(`/training-session/${trainingId}`, data)
      .then((response) => {
        dispatch(fetchTrainingSession(courseId))
        dispatch({ type: types.SET_LOADING_TRAINING, value: false })
        toast.info('The training has successfully been updated', {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
      .catch(() => {
        toast.error(
          'Something went wrong with updating this training, please try again!',
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: 'general-settings-toast',
            autoClose: 4000,
          }
        )
      })
  }
}

export const fetchTrainingSession = (courseId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/training-session/by-course/${courseId}`).then(
      (response) => {
        const { training } = response
        const trainingId = training ? training.data[0].id : null
        if (training) {
          let selectedTrainers = training.trainers.map((item) => {
            return {
              id: item.user_id,
              name: item.first_name + ' ' + item.last_name,
            }
          })

          dispatch({
            type: types.SET_TRAINING_DATA,
            value: training.data[0],
            trainers: training.trainers,
            remainingSeats: training.remaining_seats,
          })
          dispatch(selectUser(selectedTrainers))
          dispatch(onChangeTrainingType('in-person'))
          dispatch(getSelectedTrainingAssigned(trainingId, 'individual_user'))
          dispatch(getSelectedTrainingAssigned(trainingId, 'location'))
          dispatch(getSelectedTrainingAssigned(trainingId, 'location_group'))
          dispatch(getSelectedTrainingAssigned(trainingId, 'job_title'))
        }
      }
    )
  }
}
export const getSelectedTrainingAssigned = (trainingId, type) => {
  return (dispatch) => {
    AxiosInstance.get(`training-session/type/${trainingId}?type=${type}`).then(
      (data) => {
        if (type === 'individual_user') {
          const assignedUsers = data.map((item) => item.user_id)

          dispatch({
            type: SET_SELECTED_ASSIGNABLE_TRAINING_USERS,
            assignableTrainingUsers: assignedUsers,
          })
        }
        if (type === 'location_group') {
          const groupAssociates =
            data && data.length ? data.map((item) => item.group_id) : []
          dispatch({
            type: SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS,
            assignableTrainingLocationGroups: groupAssociates,
          })
        }
        if (type === 'location') {
          const assignedStores =
            data && data.length ? data.map((item) => item.store_id) : []
          dispatch({
            type: SET_SELECTED_ASSIGNABLE_TRAINING_STORES,
            assignableTrainingStores: assignedStores,
          })
        }
        if (type === 'job_title') {
          const groupRoles =
            data && data.length ? data.map((item) => item.role_id) : []
          const noDuplicatesGroupRoles = groupRoles.filter(
            (item, index) =>
              index === groupRoles.findIndex((elem) => elem === item)
          )
          dispatch({
            type: SET_SELECTED_ASSIGNABLE_TRAINING_ROLES,
            assignableTrainingRoles: noDuplicatesGroupRoles,
          })
        }
      }
    )
  }
}
export const resetTraining = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_TRAINING_DATA,
    })
    dispatch(selectUser([]))
    dispatch(onChangeTrainingType(''))
    dispatch({
      type: SET_SELECTED_ASSIGNABLE_TRAINING_USERS,
      assignableTrainingUsers: [],
    })
    dispatch({
      type: SET_SELECTED_ASSIGNABLE_TRAINING_LOCATION_GROUPS,
      assignableTrainingLocationGroups: [],
    })
    dispatch({
      type: SET_SELECTED_ASSIGNABLE_TRAINING_STORES,
      assignableTrainingStores: [],
    })
    dispatch({
      type: SET_SELECTED_ASSIGNABLE_TRAINING_ROLES,
      assignableTrainingRoles: [],
    })
  }
}

export const deleteTrainingSession = (trainingId) => {
  return (dispatch, getState) => {
    const courseId = getState().courses.id
    let language = {}
    // getState().language.language
    // 	? (language = getState().language.language.data)
    // 	: null
    if (confirm('Are you sure you want to delete this training')) {
      AxiosInstance.delete(`training-session/${trainingId}`).then(() => {
        dispatch(fetchTrainingSession(courseId))
        dispatch(resetTraining())
      })
    }
  }
}

export const fetchZoomMeetingUrls = (course_id) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/courses/${course_id}/zoom`).then((data) => {
      dispatch({ type: types.START_URL, value: data.start_url })
      dispatch({ type: types.JOIN_URL, value: data.join_url })
    })
  }
}

export const setNewCommentTextboxActive = (value) => ({
  type: types.SET_NEW_COMMENT_ACTIVE,
  value,
})

export const fetchCourseComments = (course_id) => {
  return (dispatch, getState) => {
    const { currentComment } = getState().courses
    dispatch({ type: types.SET_LOADING_COMMENTS, isLoadingComments: true })
    AxiosInstance.get(`/discussion/all/${course_id}`).then((data) => {
      let renderData = data.map((object) => {
        let avatar = JSON.parse(object.avatar)

        let areRepliesCollapsed =
          currentComment && currentComment.id === object.id ? false : true
        let replies = object.replies.map((item) => {
          let avatar = JSON.parse(item.avatar)
          return { ...item, avatar, isEditing: false }
        })
        return {
          ...object,
          avatar,
          replies,
          isEditing: false,
          areRepliesCollapsed,
        }
      })
      dispatch({ type: types.SET_COURSE_COMMENTS, data: renderData })
      dispatch({
        type: types.SET_LOADING_COMMENTS,
        isLoadingComments: false,
      })
    })
  }
}

export const onChangeComment = (value) => ({
  type: types.SET_COURSE_COMMENT,
  value,
})
// export const onChangeCommentReply = (value) => ({
// 	type: types.SET_COURSE_COMMENT_REPLY,
// 	value,
// })

export const addReplyOnClick = (replyItem, callback) => {
  return (dispatch, getState) => {
    const { courseComment } = getState().courses
    dispatch(addCommentReplies(courseComment, replyItem, callback))
  }
}

export const searchComments = (searchValueComments) => ({
  type: types.SET_SEARCH_VALUE_COMMENTS,
  searchValueComments,
})

export const addCourseComment = (callback) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_NEW_COMMENT_DISABLED, value: true })
    const { course_id, courseComment } = getState().courses
    const data = {
      comment: courseComment,
    }

    if (
      typeof courseComment !== 'string' ||
      !courseComment ||
      !courseComment.trim() ||
      !data.comment ||
      !data.comment.trim()
    ) {
      alert(
        'You can not save an empty comment. Please leave a comment or cancel!'
      )
      dispatch({ type: types.SET_NEW_COMMENT_DISABLED, value: false })
    } else {
      AxiosInstance.post(`/discussion/${course_id}`, data).then((data) => {
        dispatch({
          type: types.SET_NEW_COMMENT_DISABLED,
          value: false,
        })
        dispatch(setNewCommentTextboxActive(false))
        dispatch(fetchCourseComments(course_id))
        dispatch(onChangeComment(''))
        callback()
      })
    }
  }
}

export const deleteCourseComment = (discussionId) => {
  return (dispatch, getState) => {
    const { course_id } = getState().courses
    if (confirm('Are you sure you want to delete this comment?')) {
      AxiosInstance.delete(`discussion/${discussionId}`).then(() => {
        dispatch(fetchCourseComments(course_id))
      })
    }
  }
}
export const updateCourseComment = (discussionId) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_EDIT_COMMENT_DISABLED, value: true })
    const { course_id, courseComment, courseComments } = getState().courses
    if (courseComment !== null) {
      const data = {
        comment: courseComment,
      }
      const commentOnUpdating =
        typeof courseComment === 'object'
          ? courseComment.comment
          : courseComment
      if (!commentOnUpdating || !commentOnUpdating.trim()) {
        alert(
          'You can not save an empty comment. Please leave a comment or cancel!'
        )
        dispatch({
          type: types.SET_EDIT_COMMENT_DISABLED,
          value: false,
        })
      } else {
        AxiosInstance.put(`discussion/${discussionId}`, data).then(() => {
          dispatch({
            type: types.SET_EDIT_COMMENT_DISABLED,
            value: false,
          })
          dispatch(fetchCourseComments(course_id))
          // dispatch(setEditTextboxActive(false))
          dispatch(onChangeComment(''))
        })
      }
    }
  }
}
export const setCurrentComment = (currentComment) => {
  return (dispatch) => {
    dispatch({ type: types.SET_CURRENT_COMMENT, value: currentComment })
  }
}
export const setCurrentReply = (currentReply) => {
  return (dispatch) => {
    dispatch({ type: types.SET_CURRENT_REPLY, value: currentReply })
  }
}
// export const setEditTextboxActive = (isEditTextboxActive) => {
// 	return (dispatch) => {
// 		dispatch({
// 			type: types.SET_EDIT_TEXTBOX_ACTIVE,
// 			isEditTextboxActive,
// 		})
// 	}
// }
export const handleUpdateComment = (item) => {
  return (dispatch, getState) => {
    const { currentComment, courseComments } = getState().courses
    let temp = courseComments.map((element) => {
      let isEditing = element.id === item.id && true
      return { ...element, isEditing }
    })
    dispatch({ type: types.SET_COURSE_COMMENTS, data: temp })
    if (item.id === currentComment.id) {
      // dispatch(setEditTextboxActive(true))
      dispatch(onChangeComment(item))
    }
  }
}
export const handleUpdateCommentReply = (replyItemEdit) => {
  return (dispatch, getState) => {
    const { currentReply, courseComments, currentComment } = getState().courses
    let temp = courseComments.map((item) => {
      let replies =
        item.replies &&
        item.replies.map((replyItem) => {
          let isEditing = replyItemEdit.id === replyItem.id && true
          return { ...replyItem, isEditing }
        })
      return { ...item, replies }
    })
    dispatch({ type: types.SET_COURSE_COMMENTS, data: temp })
    if (replyItemEdit.id === currentReply.id) {
      // dispatch(setReplyTextboxActive(true))
      dispatch(onChangeComment(replyItemEdit))
    }
  }
}
export const setReplyTextboxActive = (isReplyTextboxActive) => {
  return (dispatch) => {
    dispatch({ type: types.SET_REPLY_TEXTBOX_ACTIVE, isReplyTextboxActive })
  }
}
export const addCommentReplies = (replyMessage, replyItem, callback) => {
  return (dispatch, getState) => {
    dispatch({ type: types.SET_REPLY_COMMENT_DISABLED, value: true })
    const { course_id } = getState().courses
    const data = {
      comment: replyMessage,
    }

    if (!replyMessage || !replyMessage.trim()) {
      alert('You can not save an empty reply. Please leave a reply or cancel!')
      dispatch({ type: types.SET_REPLY_COMMENT_DISABLED, value: false })
    } else {
      AxiosInstance.post(`/discussion/reply/${replyItem.id}`, data).then(() => {
        dispatch({
          type: types.SET_REPLY_COMMENT_DISABLED,
          value: false,
        })
        dispatch(fetchCourseComments(course_id))
        dispatch(setReplyTextboxActive(false))
        dispatch(onChangeComment(''))
        callback()
      })
    }
  }
}
export const handleCollapsed = (item) => {
  return (dispatch, getState) => {
    const { currentComment, courseComments } = getState().courses

    console.log(item, 'leart4630')

    let temp = courseComments.map((element) => {
      let areRepliesCollapsed =
        element.id === item.id ? !element.areRepliesCollapsed : true
      return { ...element, areRepliesCollapsed }
    })
    dispatch({ type: types.SET_COURSE_COMMENTS, data: temp })
  }
}
export const cancelEdit = (item) => {
  return (dispatch, getState) => {
    const { currentComment, courseComments } = getState().courses

    let temp = courseComments.map((element) => {
      let isEditing = element.id === item.id && false
      return { ...element, isEditing }
    })

    dispatch({ type: types.SET_COURSE_COMMENTS, data: temp })
  }
}

export const cancelEditReply = (replyItemEdit) => {
  return (dispatch, getState) => {
    const { currentReply, courseComments } = getState().courses
    let temp = courseComments.map((item) => {
      let replies =
        item.replies &&
        item.replies.map((replyItem) => {
          let isEditing = replyItem.id === replyItemEdit.id && false
          return { ...replyItem, isEditing }
        })
      return { ...item, replies }
    })
    dispatch({ type: types.SET_COURSE_COMMENTS, data: temp })
  }
}
export const setShowAssignExpanded = () => ({
  type: types.SET_ASSIGN_EXPANDED,
  assignExpanded: true,
})
export const setHideAssignExpanded = () => ({
  type: types.SET_ASSIGN_EXPANDED,
  assignExpanded: false,
})

export const setInViewCourse = (inViewCourse) => ({
  type: types.SET_IN_VIEW_COURSE,
  inViewCourse,
})

export const fetchAreAllLanguagesPromoted = (id) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/courses/promoted-all/${id}`).then((data) =>
      dispatch({
        type: types.SET_ALL_LANGUAGES_PROMOTED,
        payload: data.allLanguagesPromoted,
      })
    )
  }
}

export const promoteAllLanguages = (id) => {
  return (dispatch, getState) => {
    const { allLanguagesPromoted, promote } = getState().courses
    AxiosInstance.patch(`/courses/promote-all/${id}`, {
      promote: !allLanguagesPromoted ? 1 : 0,
    }).then((data) => {
      dispatch({
        type: types.SET_ALL_LANGUAGES_PROMOTED,
        payload: !allLanguagesPromoted ? 1 : 0,
      })
      if (allLanguagesPromoted) {
        dispatch({
          type: types.SET_COURSE_PROMOTED,
          payload: 0,
        })
      } else {
        dispatch({
          type: types.SET_COURSE_PROMOTED,
          payload: 1,
        })
      }
    })
  }
}

export const setCourseViewPermission = (courseId, isAllowed) => {
  return (dispatch, getState) => {
    const { coursesViewPermission } = getState().courses
    const newData = new Map(coursesViewPermission)

    if (newData.has(courseId) && !!newData.get(courseId)) {
      return
    }

    newData.set(courseId, isAllowed)

    dispatch({
      type: types.SET_COURSES_VIEW_PERMISSION,
      payload: newData,
    })
  }
}

export const setEnrollmentType = (type) => ({
  type: types.SET_ENROLLMENT_TYPE,
  payload: type,
})

export const setNewAccessCode = (code) => ({
  type: types.SET_NEW_ACCESS_CODE,
  payload: code,
})

export const setEnrollmentPeriodType = (period) => ({
  type: types.SET_ENROLLMENT_PERIOD_TYPE,
  payload: period,
})

export const setEnrollmentPeriod = (value) => {
  return {
    type: types.SET_ENROLLMENT_PERIOD,
    payload: value,
  }
}

export const setPrice = (value) => {
  return {
    type: types.SET_PRICE,
    payload: value,
  }
}

export const changeEnrollmentPeriodType = (period) => {
  return (dispatch) => {
    if (period === 0) {
      dispatch(setEnrollmentPeriod(null))
    }
    if (period === 1) {
      dispatch(
        setEnrollmentPeriod(moment().add(7, 'days').format('YYYY-MM-DD'))
      )
    }
    if (period === 2) {
      dispatch(setEnrollmentPeriod(50))
    }
    dispatch(setEnrollmentPeriodType(period))
    dispatch(saveCourse())
  }
}

export const changeEnrollmentPeriod = (value) => {
  return (dispatch) => {
    dispatch(setEnrollmentPeriod(value))
    dispatch(saveCourse())
  }
}

export const changePrice = (value) => {
  return (dispatch) => {
    dispatch(setPrice(value))
    dispatch(saveCourse())
  }
}

export const changeEnrollment = (type) => {
  return (dispatch) => {
    if (type === 0) {
      dispatch(setEnrollmentPeriodType(0))
      dispatch(setEnrollmentPeriod(null))
    }
    dispatch(setEnrollmentType(type))
    dispatch(saveCourse())
  }
}

export const genereateNewCode = () => {
  return (dispatch, getState) => {
    dispatch(setNewAccessCode(uuidv4()))
    dispatch(saveCourse())
  }
}

export const giveCompletionFeedback = (courseId, data) => {
  return (dispatch, getState) => {
    AxiosInstance.patch(`/courses/completion-feedback/${courseId}`, data).then(
      () => {
        dispatch(setHasGivenFeedback(true))
      }
    )
  }
}

export const agreeToTerms = (courseId) => {
  return (dispatch, getState) => {
    AxiosInstance.patch(`/courses/agree-to-terms/${courseId}`).then(() => {
      dispatch(fetchUserProgress())
      dispatch(setHasCompletedTerms(true))
    })
  }
}

export const hasAlreadyGivenCompletionFeedback = (courseId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/courses/completion-feedback/${courseId}`).then(
      (data) => {
        dispatch(setHasGivenFeedback(data))
      }
    )
  }
}

export const hasCompletedTerms = (courseId, setState) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/courses/completed-terms/${courseId}`).then((data) =>
      dispatch(setHasCompletedTerms(data))
    )
  }
}

export const setHasGivenFeedback = (payload) => ({
  type: types.SET_HAS_GIVEN_FEEDBACK,
  payload,
})

export const setHasCompletedTerms = (payload) => ({
  type: types.SET_COMPLETED_TERMS,
  payload,
})
